import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import {
    PURCHASE_ORDER_PAYMENT_METHOD,
    PURCHASE_ORDER_PAYMENT_STATUS,
    PURCHASE_ORDER_STATUS,
    SERVER_URL,
    TILL_PRICE_CALCULATION_METHOD,
    TILL_PRICE_ITEM_CALCULATION_METHOD
} from "../../shared/utils/Constants";
import FormSection from "../../shared/component/form/FormSection";
import DateInput from "../../shared/component/form/DateInput";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";
import PurchaseRequisitionService from "../../shared/service/PurchaseRequisitionService";
import SupplierService from "../../shared/service/SupplierService";
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import PurchaseOrderItemColumn from "../../shared/component/dataTable/columns/PurchaseOrderItemColumn.json";
import PurchaseOrderItemMobileColumn from "../../shared/component/dataTable/columns/PurchaseOrderItemMobileColumn.json";
import PurchaseOrderItemResizableColumn
    from "../../shared/component/dataTable/columns/PurchaseOrderItemResizableColumn.json";
import PurchaseOrderInvoiceDnCompareColumn from "../../shared/component/dataTable/columns/PurchaseOrderInvoiceDnCompareColumn.json";
import DataTable from "../../shared/component/dataTable/DataTable";
import PurchaseRequisitionItemDataTable from "../purchaserequisition/PurchaseRequisitionItemDataTable";
import {
    buildInvoiceDeliveryNoteComparisonRows,
    buildInvoiceDnResolutionPayload,
    buildInvoiceShortageConfirmMessage,
    countInvoiceDnComparisonIssues,
    countPendingOnlyOnDnActions,
    DN_ONLY_DISPOSITION,
    getInvoiceShortageRows,
    normalizeDnOnlyDisposition
} from "./PurchaseOrderCompareUtils";
import {
    applyInvoiceItemSnapshot,
    clearDnResolutionAssignmentFields,
    clearDnResolutionState,
    DN_MATCH_GROUP,
    filterAvailableDnItems,
    formatDnOptionLabel,
    getDnItemKey,
    getInvoiceDnResolutionItems,
    getInvoiceItemKey,
    groupRankedDnOptions,
    hydrateDnResolutionSelectionsFromBarcodes,
    loadDnResolutionState,
    rankDeliveryNoteOptionsForInvoiceItem,
    saveDnResolutionState,
    snapshotInvoiceItemForDnResolution
} from "./PurchaseOrderDnResolutionUtils";

import Dialog from "../../shared/component/dialog/Dialog";
import PurchaseOrderItemSave from "./PurchaseOrderItemSave";
import {RadioButton} from "primereact/radiobutton";
import {TabPanel, TabView} from 'primereact/tabview';
import {toast} from "react-toastify";
import ProductService from "../../shared/service/ProductService";
import {FileUpload} from "primereact/fileupload";
import Loading from "../../shared/component/others/Loading";
import DepartmentService from "../../shared/service/DepartmentService";
import cloneDeep from 'lodash/cloneDeep';
import Decimal from "../storemanagement/decimal.mjs";
import {Checkbox} from "primereact/checkbox";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import SupplierFilter from "../storemanagement/SupplierFilter";
import NumberFormat from 'react-number-format';
import CalculationUtils from "../../shared/utils/CalculationUtils";
import MerchantUserService from "../../shared/service/MerchantUserService";
import MerchantBranchSettingsService from "../../shared/service/MerchantBranchSettingsService";
import '../../shared/styles/SettingsPage.css';

dayjs.extend(customParseFormat);

/** Sentinel id for “no Delivery Note” (NONE) on upload invoices. */
export const DELIVERY_NOTE_NONE_ID = -1;

function isNoneDeliveryNoteId(id) {
    return id === DELIVERY_NOTE_NONE_ID
        || id === -1
        || id === '-1'
        || Number(id) === DELIVERY_NOTE_NONE_ID;
}

function isDeliveryNoteNoneFlag(value) {
    return value === true || value === 'true';
}

const defaultLicense = {
    id: null,
    bssId: null,
    invoiceNumber: null,
    deliveryDate: null,
    invoiceDate: null,
    createDate: null,
    purchaseOrderStatus: 'INVOICE',
    invoiceType: "MANUAL_ENTRY",
    itemList: [],

    totalNet: null,
    totalAmount: null,
    totalTax: null,
    discountAmount: null,
    tillPriceCalculationMethod: "NEAREST_9",
    applyCurrentPriceFromBarcodeOnUpdate: false,
    printQueueTillUserBssId: null,

    supplierBssId: null,
    supplierName: null,
    supplierApproved: false,
    includeTax: false,
    useInvoiceBarcode: true,
    readBoxQuantityFromProduct: false,
    supplierAccountCode: null,
    supplierPhoneNumber: null,
    addressLine1: null,
    addressLine2: null,
    addressLine3: null,
    addressLine4: null,
    postcode: null,
    city: null,
    md5sum: null,
    totalFileCount: null,
    processedFileCount: null,
    assignedDeliveryNoteId: null,
    assignedDeliveryNoteNo: null,
    deliveryNoteNone: false,
    createReturnFromInvoiceShortage: false,
    paymentList: [],
    paidAmount: 0,
    paymentStatus: 'UNPAID',
    remainingAmount: null,
    paymentDueDate: null

};
const defaultItem = {
    id: null,
    bssId: null,

    // fixed
    barcode: null,
    productCode: null,
    generatedProductCode: null,
    itemName: null,
    boxUnitMeasure: null,       // this is not needed, included if needed later
    itemUnitMeasure: null,
    itemSize: null,
    taxRate: null,
    weighable: false,           // default is false

    // variable
    orderQuantity: null,
    deliveryQuantity: null,
    boxSize: null,
    unitPrice: null,
    totalPrice: null,
    taxPrice: null,
    discount: null,
    taxAmount: null,

    // optional / calculated / future fields
    itemBssId: null,
    salePrice: null,
    profitMargin: null,
    expiryDate: null,
    orjDescription: null,
    itemClosed: false,
    barcodeIsSearched: false,
    tillPriceCalculationMethod: null,
    newCodedProduct: false,
    printQueueTillUserBssId: null,
    maxOrjStock: null,
    maxStock: null,
    minStock: null,
    status: 'ACTIVE',
    priceMark: null,
    currentBoxPrice: null,
    currentBoxSize: null,
    currentUnitCost: null,
    importWarning: null
};

const INVOICE_TILL_PRICE_CALCULATION_METHOD = [
    ...TILL_PRICE_CALCULATION_METHOD,
    {name: 'CURRENT_PRICE', value: 'CURRENT_PRICE'}
];


export default class PurchaseOrderSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            license: Object.assign({}, defaultLicense),
            licenseTemp: Object.assign({}, defaultLicense),
            renderExtraDataDeleteButton: false,
            pageMode: null,
            purchaseOrderItemListFields:[],
            defaultCostPricePercentage: 0,
            filteredProducts: [],
            departmentList: [],
            tillUserList: [],
            filterOption: "all",
            supplierList: [],
            selectValue: 'Barcode',
            processButton: "process",
            /** true: büyüteç / satır seçimi; false: Process New veya Process Pending akışı */
            itemDialogOpenedFromItem: true,
            loading: false,
            first: 0,
            rows: 10,
            showCurrentPriceConfirmModal: false,
            pendingTillPriceCalculationMethod: null,
            tillPriceMethodSelectKey: 0,
            selectedDeliveryNoteId: null,
            displayAssignDeliveryNoteDialog: false,
            assignedDeliveryNote: null,
            assignDeliveryNoteList: [],
            assignDeliveryNoteLoading: false,
            unlinkedDeliveryNoteCount: 0,
            invoiceDnComparisonRows: [],
            /** barcode → ACCEPTED | SCANNING_ERROR | WRONG_ITEM (Only-on-DN compare). */
            invoiceDnDispositions: {},
            /** invoice item key → original fields before DN barcode assign (for Revert). */
            invoiceDnResolutionSnapshots: {},
            /** invoice item key → selected DN item key. */
            invoiceDnResolutionSelections: {},
            /** invoice item key → selected DN option label (keeps combo text after refresh). */
            invoiceDnResolutionSelectionLabels: {},
            invoiceDetailTabIndex: 0,
            createReturnFromShortageChecked: true,
            showCreateReturnShortageCheckbox: false,
            paymentDraftList: [],
            paymentSaving: false,
            paymentsLocked: false,
            showNoneDeliveryNoteConfirmModal: false,
        }
        this.purchaseOrderService = new PurchaseOrderService();
        this.purchaseRequisitionService = new PurchaseRequisitionService();
        this.supplierService = new SupplierService();
        this.productService = new ProductService();
        this.departmentService = new DepartmentService();
        this.merchantUserService = new MerchantUserService();
        this.merchantBranchSettingsService = new MerchantBranchSettingsService();
    }

    /**
     * Parse id + invoiceType from hash. Browsers often turn the 2nd "?" into "&",
     * so "#purchaseOrderSave?41768?UPLOAD" becomes "...?41768&UPLOAD" and a naive
     * split('?')[1] wrongly yields "41768&UPLOAD" → API 400.
     */
    resolvePurchaseOrderSaveRouteParams = () => {
        const hash = window.location.hash || '';
        const marker = 'purchaseOrderSave';
        const markerIndex = hash.indexOf(marker);
        if (markerIndex < 0) {
            return {id: null, invoiceType: null};
        }
        let rest = hash.substring(markerIndex + marker.length);
        rest = rest.replace(/^[?/#]+/, '');
        const parts = rest.split(/[?&/]/).map(part => String(part || '').trim()).filter(Boolean);
        let id = parts[0] || null;
        let invoiceType = parts[1] || null;
        if (id && /[&?]/.test(id)) {
            const splitId = id.split(/[&?]/).filter(Boolean);
            id = splitId[0] || id;
            if (!invoiceType && splitId[1]) {
                invoiceType = splitId[1];
            }
        }
        if (id != null) {
            const match = String(id).match(/^(-?\d+)/);
            id = match ? match[1] : id;
        }
        if (invoiceType) {
            invoiceType = String(invoiceType).split(/[&#]/)[0];
        }
        return {id, invoiceType};
    };

    componentDidMount() {

        this.departmentService.findAll().then(response => this.setState({departmentList: response}));

        this.merchantUserService.getTillUsers(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    tillUserList: response,
                });
            }

        });

        const {id, invoiceType} = this.resolvePurchaseOrderSaveRouteParams();

        if (!GeneralUtils.__isValueEmpty(id) && id != "-1") {

            this.purchaseOrderService.findById(id).then(response => {
                    let responseObject = Object.assign({}, response);
                    responseObject.deliveryNoteNone = isDeliveryNoteNoneFlag(responseObject.deliveryNoteNone)
                        || isNoneDeliveryNoteId(responseObject.assignedDeliveryNoteId);
                    if (responseObject.deliveryNoteNone) {
                        responseObject.assignedDeliveryNoteId = DELIVERY_NOTE_NONE_ID;
                        responseObject.assignedDeliveryNoteNo = 'NONE';
                    }
                    let responseObjectTemp = Object.assign({}, responseObject);
                    const invoiceDetailTabIndex = this.resolveInitialDetailTabIndex(responseObject);
                    this.setState({
                        license: responseObject, licenseTemp: responseObjectTemp, licenseSaveButtonRender: true,
                        paymentDraftList: this.clonePaymentDraftList(responseObject.paymentList),
                        paymentsLocked: (responseObject.paymentList || []).length > 0,
                        invoiceDetailTabIndex
                    }, () => {
                        this.loadAssignedDeliveryNoteForCompare(responseObject.assignedDeliveryNoteId);
                        this.refreshUnlinkedDeliveryNoteCount();
                    });

                    if(response.invoiceNumber == "ERROR"){
                        this.setState({
                           licenseSaveButtonRender: false
                        });

                    }
                    else{
                        this.setState({
                            license: responseObject, licenseTemp: responseObjectTemp, licenseSaveButtonRender: true,
                            paymentDraftList: this.clonePaymentDraftList(responseObject.paymentList),
                            paymentsLocked: (responseObject.paymentList || []).length > 0,
                            invoiceDetailTabIndex
                        }, () => {
                            this.loadAssignedDeliveryNoteForCompare(responseObject.assignedDeliveryNoteId);
                            this.refreshUnlinkedDeliveryNoteCount();
                            const approved = this.checkSupplierApproved();
                            if (approved) {
                                const allEditButtons = document.querySelectorAll('.p-row-editor-init-icon');
                                if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED") {
                                    allEditButtons.forEach((btn) => {
                                        btn.click();
                                    });
                                }


                            }
                        });
                    }




                }
            );

        } else {
            let obj1 = Object.assign({}, defaultLicense, {invoiceType: invoiceType});


            obj1.itemList = [];
            this.setState({
                license: obj1,
                licenseSaveButtonRender: true,
                renderExtraDataDeleteButton: false,
                licenseTemp: Object.assign({}, obj1)
            }, () => {
            });

        }

        this.supplierService.findAll().then(response => this.setState({supplierList: response}));
        this.loadFields();
    }

    loadFields = () => {

        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        purchaseOrderItemListFields: response.purchaseOrderItemListFields,
                        defaultCostPricePercentage: response.defaultCostPricePercentage != null ? response.defaultCostPricePercentage : 0
                    });
                }
            });
    }

    renderImportCsv() {
        if (
            !GeneralUtils.isNullOrEmpty(this.state.license?.id) && this.state.license?.itemList.length == 0 &&
            this.state.license.invoiceType === "CSV"
        ) {
            return (
                <FormSection title={"Upload Csv Item List"}>
                    <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                        <FileUpload
                            name="csvFile"
                            accept=".csv"
                            maxFileSize={15000000}
                            onValidationFailError={GeneralUtils.onValidationFailErrorFile}
                            invalidFileSizeMessageDetail="Maximum upload size is 15MB."
                            chooseLabel="Choose CSV File"
                            disabled={false}
                            ref={(elem) => (this.refUploadInputCsv = elem)}
                            mode="basic"
                            style={{height: "30px"}}
                        />

                        <Button
                            color="outline-primary"
                            className="settings-page__btn--action"
                            onClick={() => this.importCsv(this.state.license.id)}
                        >
                            <Translate contentKey="entity.action.add">Upload CSV</Translate>
                        </Button>

                        <Button
                            color="outline-primary"
                            className="settings-page__btn--secondary settings-page__btn--wrap"
                            onClick={() => this.downloadCsvSample()}
                        >
                            <Translate contentKey="entity.action.add">Download CSV Sample</Translate>
                        </Button>
                    </div>
                </FormSection>
            );
        }
        return null;
    }

    renderUploadImage() {
        if (this.state.license.invoiceType == "UPLOAD" && GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            return (
                <div>
                    <ModalConfirm
                        show={this.state.showDuplicateModal}
                        header="Confirm"
                        message={this.state.duplicateConfirmMessage}
                        onOkClick={() => {
                            if (this.state.duplicateConfirmAction) this.state.duplicateConfirmAction();
                            this.setState({
                                showDuplicateModal: false,
                                duplicateConfirmAction: null,
                                duplicateConfirmMessage: ""
                            });
                        }}
                        onCancelClick={() =>
                            this.setState({
                                showDuplicateModal: false,
                                duplicateConfirmAction: null,
                                duplicateConfirmMessage: ""
                            })
                        }
                        ok="Yes"
                        cancel="No"
                    />


                    <FormSection title={"Upload Invoice(s)"}>
                        <FileUpload
                            name="images"
                            maxFileSize={15000000}
                            onValidationFailError={GeneralUtils.onValidationFailErrorFile}
                            invalidFileSizeMessageDetail="Maximum upload size is 15MB."
                            chooseLabel={"Choose"}
                            multiple
                            disabled={false}
                            customUpload={true}
                            uploadHandler={this.handleCustomUpload}
                            ref={elem => this.refUploadInputImage = elem}
                            mode="advanced"
                        />


                    </FormSection>

                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--back" onClick={() => {

                        let obj1 = Object.assign({}, defaultLicense);
                        obj1.itemList = [];
                        this.setState({
                            license: obj1,
                            licenseTemp: Object.assign({}, obj1)
                        }, () => {
                            window.location.href = "#purchaseOrder";
                        });


                    }}>
                        <Translate contentKey="entity.action.cancel">Back</Translate>
                    </Button>
                </div>
            );
        }
    }

    handleCustomUpload = async (event) => {
        this.setState({loading: true});
        const files = event.files;

        if (!GeneralUtils.isNullOrEmpty(files) && files.length > 0) {
            const formData = new FormData();

            for (let i = 0; i < files.length; i++) {
                formData.append("files", files[i]);
            }

            try {
                const checkResponse = await this.purchaseOrderService.checkSum5(formData);

                if (checkResponse === false) {
                    // ⚡ Duplicate fatura uyarısı için ayrı state kullanıyoruz
                    this.setState({
                        showDuplicateModal: true,
                        loading: false,
                        duplicateConfirmMessage: "This invoice has already been uploaded. Do you want to continue anyway?",
                        duplicateConfirmAction: async () => {
                            this.setState({showDuplicateModal: false, loading: true});

                            // Upload işlemini başlat
                            this.purchaseOrderService.uploadInvoiceDocument(formData)
                                .then(response => {
                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                        if (this.refUploadInputImage?.clear) {
                                            this.refUploadInputImage.clear();
                                        }

                                        setTimeout(() => {
                                            this.purchaseOrderService.findById(response.id).then(response => {
                                                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                                    window.location.href = "#purchaseOrder";
                                                } else {
                                                    toast.warn("The uploaded image could not be processed. Please try uploading a different image");
                                                    window.location.href = "#purchaseOrder";
                                                }
                                            });
                                        }, 1000);
                                    }
                                })
                                .finally(() => this.setState({loading: false}));
                        }
                    });

                    return;
                }

                // ✅ Normal upload
                this.purchaseOrderService.uploadInvoiceDocument(formData)
                    .then(response => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            if (this.refUploadInputImage?.clear) {
                                this.refUploadInputImage.clear();
                            }

                            setTimeout(() => {
                                this.purchaseOrderService.findById(response.id).then(response => {
                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                        window.location.href = "#purchaseOrder";
                                    } else {
                                        toast.warn("The uploaded image could not be processed. Please try uploading a different image");
                                        window.location.href = "#purchaseOrder";
                                    }
                                });
                            }, 1000);
                        }
                    })
                    .finally(() => this.setState({loading: false}));

            } catch (error) {
                console.error(error);
                toast.error("An error occurred while checking the invoice.");
                this.setState({loading: false});
            }

        } else {
            this.setState({loading: false});
            toast.warn("Please select at least one image.");
        }
    };


    renderPurchaseOrder() {
        const isMobile = GeneralUtils.isMobile();
        //halil
        const { license, filterOption } = this.state;
        const allItems = license?.itemList || [];
        const activeItems = allItems.filter(item => item.status === "ACTIVE");
        const duplicateItems = this.getDuplicateItems(activeItems);
        const duplicateItemIds = new Set(
            duplicateItems.map(item =>
                item.id != null ? `id:${item.id}` : `key:${item.barcode || ''}|${item.productCode || ''}`
            )
        );

        const filteredItems = allItems
            .filter(item => {
                const key =
                    item.id != null ? `id:${item.id}` : `key:${item.barcode || ''}|${item.productCode || ''}`;

                switch (filterOption) {
                    case 'productUnmatched':
                        return item.barcodeIsSearched !== true;

                    case 'priceUnmatched':
                        return item.oldPrice !== item.salePrice;

                    case 'productNew':
                        return item.barcodeIsSearched === true && item.itemBssId == null;

                    case 'duplicates':
                        return duplicateItemIds.has(key);

                    default:
                        return true;
                }
            })
            .map((item, index) => ({ ...this.calculateFields(item), _rowNo: index + 1 }));






        if ((this.state.license.invoiceType == "UPLOAD" && !GeneralUtils.isNullOrEmpty(this.state.license.id)) || this.isManualStyleInvoice() || this.state.license.invoiceType == "CSV") {


            return (
                <div>


                    <FormSection className="invoice-detail-section" title={this.getInvoiceDetailSectionTitle()}>


                        <ModalConfirm header='Warning' ok='OK' onOkClick={this.deleteInvoice}
                                      onCancelClick={() => this.setState({displayShowInvoiceDialog: false})}
                                      show={this.state.displayShowInvoiceDialog}
                                      message={this.state.noticeResponse}/>
                        <div className="invoice-detail-layout">
                            <div className="invoice-detail-main">
                                <div className="invoice-detail-fields invoice-detail-fields--matrix">
                                    {this.renderSupplierNameField()}
                                    {this.renderInvoiceDateField()}
                                    {this.renderInvoiceNumberField()}
                                    {this.renderTillPriceCalculatorField()}
                                    {this.renderTillUserField()}

                                    {this.renderInvoiceSubtotalField()}
                                    {this.renderInvoiceTotalField()}
                                    <div className="invoice-detail-number-metrics">
                                        {this.renderInvoiceItemsTotalField()}
                                        {this.renderInvoiceTotalProfitField()}
                                    </div>
                                    {this.renderInvoiceOptionCheckboxes()}
                                </div>

                                <Dialog
                                    visible={this.state.displayDialogFilter}
                                    header={"Supplier"}
                                    onHide={() => this.setState({displayDialogFilter: false})}
                                    style={GeneralUtils.getDialogStyleForSupplierFilter()}
                                >
                                    <SupplierFilter
                                        ref={(elem) => (this.refModelCredentialsSave = elem)}
                                        onDataSelect={this.onDataSelectFilter}
                                        closeDisplayDialog={this.closeDisplayDialogFilter}
                                    />
                                </Dialog>
                            </div>

                            {this.renderInvoiceHeaderSidePanel()}
                        </div>


                        {(() => {
                            const isClosed = this.state.license.purchaseOrderStatus === 'CLOSED';
                            const showCompare = this.isUploadInvoice()
                                && !GeneralUtils.isNullOrEmpty(this.state.license?.assignedDeliveryNoteId)
                                && !isNoneDeliveryNoteId(this.state.license?.assignedDeliveryNoteId);
                            if (!showCompare && !isClosed) {
                                return this.renderInvoiceItemsSection(filteredItems, isMobile);
                            }
                            const tabPanels = [
                                <TabPanel key="invoice" header="Invoice">
                                    {this.renderInvoiceItemsSection(filteredItems, isMobile)}
                                </TabPanel>
                            ];
                            if (showCompare) {
                                tabPanels.push(
                                    <TabPanel key="compare" header={this.getInvoiceCompareTabHeader()}>
                                        {this.renderInvoiceDeliveryNoteCompareSection()}
                                    </TabPanel>
                                );
                                tabPanels.push(
                                    <TabPanel key="resolution" header={this.getInvoiceDnResolutionTabHeader()}>
                                        {this.renderInvoiceDnResolutionSection()}
                                    </TabPanel>
                                );
                            }
                            if (isClosed) {
                                tabPanels.push(
                                    <TabPanel key="payments" header="Payments">
                                        {this.renderPaymentSection()}
                                    </TabPanel>
                                );
                            }
                            return (
                                <TabView
                                    className="settings-page__tabs"
                                    activeIndex={this.state.invoiceDetailTabIndex || 0}
                                    onTabChange={(e) => this.setState({invoiceDetailTabIndex: e.index})}
                                >
                                    {tabPanels}
                                </TabView>
                            );
                        })()}


                        <div className="settings-page__actions settings-page__actions--equal-height">
                        {this.state.license.purchaseOrderStatus != "CLOSED" && !this.state.licenseSaveButtonRender && this.state.license.invoiceNumber != "ERROR" &&
                            <Button color="outline-primary" className="settings-page__btn--edit"
                                    onClick={() => {

                                        this.setState({
                                            licenseSaveButtonRender: true
                                        }, () => {
                                            this.setAllRowsEditable();
                                        });

                                    }}>
                                <Translate contentKey="entity.action.add">Edit</Translate>
                            </Button>}


                        {this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" &&  this.state.license.invoiceNumber != "ERROR" &&
                            <Button color="outline-primary" className="settings-page__btn--save"
                                    onClick={() => {
                                        const approved = this.checkSupplierApproved();
                                        if (approved) {
                                            this.savePurchaseOrderItem(false);
                                        } else {
                                            return toast.warn("Please approve supplier to continue");
                                        }


                                    }}>
                                <Translate contentKey="entity.action.add">Save</Translate>
                            </Button>
                        }

                        {this.renderImportCsv()}


                        {!GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                            this.state.license.purchaseOrderStatus !== "CLOSED" &&  this.state.license.invoiceNumber != "ERROR" &&

                            (() => {
                                const itemList = this.state.license.itemList || [];
                                const hasUnsearched = itemList.some(
                                    item => item.barcodeIsSearched && item.itemBssId == null && item.status === "ACTIVE"
                                );

                                if (hasUnsearched) {
                                    return (
                                        <Button
                                            color="outline-primary"
                                            className="settings-page__btn--action"
                                            onClick={() => {
                                                this.setState({
                                                    processButton: "new",
                                                });
                                                this.openFirstNewItem();
                                            }}
                                        >
                                            <Translate contentKey="entity.action.cancel">Process New</Translate>
                                        </Button>
                                    );
                                }
                                return null; // bu eklenmeli aksi halde undefined render hatası olur
                            })()}


                        {!GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                            this.state.license.purchaseOrderStatus !== "CLOSED" &&  this.state.license.invoiceNumber != "ERROR" &&
                            (() => {
                                const itemList = this.state.license.itemList || [];
                                const hasUnsearched = itemList.some(item => !item.barcodeIsSearched && item.status === "ACTIVE");
                                const activeItemsForDup = itemList.filter(item => item.status === "ACTIVE");
                                const duplicateCount = this.getDuplicateItems(activeItemsForDup).length;

                                // 1) Her zaman önce pending/duplicate aksiyonları göster
                                if (hasUnsearched || duplicateCount > 0) {
                                    return (
                                        <>
                                            {hasUnsearched && (
                                                <Button
                                                    color="outline-primary"
                                                    className="settings-page__btn--action settings-page__btn--process-pending"
                                                    onClick={() => {
                                                        this.setState({
                                                            processButton: "process",
                                                        });
                                                        this.openFirstUnsearchedItem();
                                                    }}
                                                >
                                                    <Translate contentKey="entity.action.cancel">Process Pending</Translate>
                                                </Button>
                                            )}

                                            {duplicateCount > 0 && (
                                                <Button
                                                    color="outline-danger"
                                                    className="settings-page__btn--delete settings-page__btn--revert-duplicates"
                                                    onClick={this.revertDuplicateItems}
                                                >
                                                    Revert Duplicates ({duplicateCount})
                                                </Button>
                                            )}
                                        </>
                                    );
                                } else {
                                    return (
                                        <>
                                            <Button
                                                color="outline-primary"
                                                className="settings-page__btn--save"
                                                onClick={() => {
                                                    this.confirmInvoice(true);
                                                }}
                                            >
                                                <Translate contentKey="entity.action.cancel">Confirm</Translate>
                                            </Button>


                                            <ModalConfirm
                                                show={this.state.showConfirmModal}
                                                header="Confirm"
                                                message={this.state.confirmMessage}
                                                checkboxLabel={this.state.showCreateReturnShortageCheckbox
                                                    ? "Create Open Return for shortage"
                                                    : null}
                                                checkboxChecked={this.state.createReturnFromShortageChecked}
                                                onCheckboxChange={(checked) =>
                                                    this.setState({createReturnFromShortageChecked: checked})
                                                }
                                                onOkClick={() => {
                                                    if (this.state.confirmAction) this.state.confirmAction();
                                                    this.setState({
                                                        showConfirmModal: false,
                                                        confirmAction: null,
                                                        confirmMessage: "",
                                                        showCreateReturnShortageCheckbox: false
                                                    });
                                                }}
                                                onCancelClick={() =>
                                                    this.setState({
                                                        showConfirmModal: false,
                                                        confirmAction: null,
                                                        confirmMessage: "",
                                                        showCreateReturnShortageCheckbox: false
                                                    })
                                                }
                                                ok="Yes"
                                                cancel="No"
                                            />

                                        </>
                                    );
                                }
                            })()}


                        {!GeneralUtils.isNullOrEmpty(this.state.license.id) && (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED") &&
                            <Button color="outline-danger" className="settings-page__btn--delete"
                                    onClick={() => {
                                        this.showInvoiceDeleteConfirmDialog()
                                    }}>
                                <Translate contentKey="entity.action.cancel">Delete</Translate>
                            </Button>}

                        <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--back"
                                onClick={() => {
                                let obj1 = Object.assign({}, defaultLicense);
                                obj1.itemList = [];

                                this.setState({
                                    license: obj1,
                                    licenseTemp: Object.assign({}, obj1)
                                }, () => {
                                    window.location.href = "#purchaseOrder";

                                });

                            }}>
                        <Translate contentKey="entity.action.cancel">Back</Translate>
                    </Button>
                        </div>

                    </FormSection>
                </div>
            )

        }
    };

    openFirstNewItem = () => {
        const {license} = this.state;
        const itemList = license['itemList'] || [];

        if (this.checkSupplierApproved()) {
            const firstNewItem = itemList.find(item => item.barcodeIsSearched && item.itemBssId == null && item.status === "ACTIVE");

            if (firstNewItem) {
                this.onDataSelect(firstNewItem, false);

            } else {
                toast.info("No new items found.");
            }
        } else {
            toast.warn("Please approve supplier to continue");
        }


    };

    openFirstUnsearchedItem = () => {
        const {license} = this.state;
        const itemList = license['itemList'] || [];

        if (this.checkSupplierApproved()) {
            const firstUnsearched = itemList.find(item => !item.barcodeIsSearched && item.status === "ACTIVE");

            if (firstUnsearched) {
                this.onDataSelect(firstUnsearched, false);

            } else {
                toast.info("No unmatched items found.");
            }
        } else {
            toast.warn("Please approve supplier to continue");
        }


    };


    downloadCsvSample = async () => {
        const response = await this.purchaseOrderService.downloadCsvSample();

        if (response && response.file && response.fileName && response.fileType) {
            // Base64'ü arrayBuffer'a çevir
            const byteCharacters = atob(response.file);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Blob oluştur ve direkt indir
            const blob = new Blob([byteArray], {type: response.fileType});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = response.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            GeneralUtils.notification("CSV sample file not found!");
        }
    };


    checkSupplierApproved = () => {
        const {invoiceType, supplierApproved, supplierId} = this.state.license;
        //return !(invoiceType === "UPLOAD" && supplierApproved === false && supplierId == null);
        return !(invoiceType === "UPLOAD" && supplierApproved === false);
    };

    setAllRowsEditable = () => {
        try {
            const approved = this.checkSupplierApproved();
            if (approved) {
                const allEditButtons = document.querySelectorAll('.p-row-editor-init-icon');
                if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED") {
                    allEditButtons.forEach((btn) => {
                        btn.click();
                    });
                }


            } else {
                return toast.warn("Please approve supplier to continue");
            }


        } catch (e) {

        }


    };


    renderFilter() {
        const isMobile = GeneralUtils.isMobile();
        const itemList = this.state.license?.itemList || [];
        const filterCounts = this.getFilterCounts(itemList);

        const renderFilterOption = (inputId, value, label, count, warn = false) => (
            <label
                className={`settings-page__po-item-filter${warn && count > 0 ? ' settings-page__po-item-filter--warn' : ''}`}
                htmlFor={inputId}
                key={inputId}
            >
                <RadioButton
                    inputId={inputId}
                    name="filter"
                    value={value}
                    onChange={this.handleFilterChange}
                    checked={this.state.filterOption === value}
                />
                <span className="settings-page__po-item-filter__text">
                    {label}
                    <span className="settings-page__po-item-filter-count">({count})</span>
                </span>
            </label>
        );

        return (
            <div className={`settings-page__po-item-filters${isMobile ? ' settings-page__po-item-filters--mobile' : ''}`}>
                {renderFilterOption('all', 'all', 'All', filterCounts.all)}
                {renderFilterOption('priceUnmatched', 'priceUnmatched', 'Updated Price', filterCounts.priceUnmatched)}
                {renderFilterOption('productUnmatched', 'productUnmatched', 'Pending', filterCounts.productUnmatched)}
                {renderFilterOption('productNew', 'productNew', 'New', filterCounts.productNew)}
                {renderFilterOption('duplicates', 'duplicates', 'Duplicates', filterCounts.duplicates, true)}

                {this.state.license.purchaseOrderStatus != "CLOSED" &&
                    this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED" &&
                    !this.state.licenseSaveButtonRender &&
                    !GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                    this.checkSupplierApproved() && (
                        <div className="settings-page__po-item-filters__action">
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--add"
                                style={isMobile ? undefined : {minWidth: '10.5rem'}}
                                onClick={() => {
                                    const newItem = Object.assign({}, defaultItem);
                                    newItem.tillPriceCalculationMethod = 'MANUAL_ENTRY';
                                    this.onDataSelect(newItem, false);
                                }}
                            >
                                <Translate contentKey="entity.action.add">Add New Item</Translate>
                            </Button>
                        </div>
                    )}
            </div>
        );
    }


    handleFilterChange = (e) => {
        this.setState({filterOption: e.value}, () => {
        });
    };

    getFilterCounts = (itemList) => {
        const safeList = Array.isArray(itemList) ? itemList : [];
        const activeOnly = safeList.filter(item => item.status === "ACTIVE");

        return {
            all: safeList.length,
            productUnmatched: safeList.filter(item => item.barcodeIsSearched !== true).length,
            priceUnmatched: safeList.filter(item => item.oldPrice !== item.salePrice).length,
            productNew: safeList.filter(item => item.barcodeIsSearched === true && item.itemBssId == null).length,
            duplicates: this.getDuplicateItems(activeOnly).length
        };
    };

    /**
     * Aynı barcode'a sahip fakat farklı productCode'ları olan tüm item'ları döner.
     * Şimdilik sadece UI filtreleri ve şart kontrolleri için kullanılıyor.
     */
    getDuplicateItems = (itemList) => {
        const safeList = Array.isArray(itemList) ? itemList : [];
        const barcodeToProductCodes = new Map();
        const barcodeToItems = new Map();

        safeList.forEach(item => {
            if (!item || !item.barcode || !item.productCode) {
                return;
            }
            const barcode = item.barcode;
            const productCode = item.productCode;

            if (!barcodeToProductCodes.has(barcode)) {
                barcodeToProductCodes.set(barcode, new Set());
            }
            if (!barcodeToItems.has(barcode)) {
                barcodeToItems.set(barcode, []);
            }

            barcodeToProductCodes.get(barcode).add(productCode);
            barcodeToItems.get(barcode).push(item);
        });

        const duplicates = [];
        barcodeToProductCodes.forEach((productCodes, barcode) => {
            if (productCodes.size > 1) {
                const itemsForBarcode = barcodeToItems.get(barcode) || [];
                duplicates.push(...itemsForBarcode);
            }
        });

        return duplicates;
    };

    /**
     * Aynı barcode'a sahip fakat farklı productCode'ları olan item'lar için
     * revert işlemini tetikler. Backend'de invoice tekrar işlenir ve
     * güncel invoice DTO'su geri dönerek ekrandaki liste yenilenir.
     */
    revertDuplicateItems = () => {
        const license = this.state.license || {};
        const activeItems = (license.itemList || []).filter(item => item.status === "ACTIVE");
        const duplicateItems = this.getDuplicateItems(activeItems);
        const duplicatesCount = duplicateItems.length;

        if (GeneralUtils.isNullOrEmpty(license.id)) {
            return toast.warn("Please save the invoice before reverting items.");
        }

        if (duplicatesCount === 0) {
            return toast.info("No duplicate items found.");
        }

        this.setState({loading: true});
        this.purchaseOrderService.revertDuplicateItems(license.id)
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        license: Object.assign({}, response),
                        licenseTemp: Object.assign({}, response),
                        loading: false
                    });
                } else {
                    this.setState({loading: false});
                }
            })
            .catch(() => {
                this.setState({loading: false});
            });
    };


    /**
     * Manual invoice: add items like Upload/PR — toolbar button opens item dialog
     * (barcode/name search is inside the dialog, not an inline Select Product strip).
     */
    /**
     * Legacy Select Product strip was removed; "Add New Item" lives in filter toolbar
     * (same conditions/style as development).
     */
    renderSelectItems() {
        return null;
    };


    onDataSelect = (data, isOpenFromItem) => {
        if (isOpenFromItem === undefined || isOpenFromItem === null) {
            isOpenFromItem = true;
        }
        const approved = this.checkSupplierApproved();
        if (approved) {
            const isEditMode = this.state.licenseSaveButtonRender && this.checkSupplierApproved();
            GeneralUtils.openDialogThenRef(this, {
                displayDialog: true,
                itemDialogOpenedFromItem: isOpenFromItem
            }, () => this.refModelSave, (ref) => {
                ref.setData(data, this.state.license.purchaseOrderStatus, this.state.license.invoiceType, isOpenFromItem, this.state.license.tillPriceCalculationMethod, this.state.license.printQueueTillUserBssId, isEditMode);
            });
        } else {
            return toast.warn("Please approve supplier to continue");
        }


    }

    __handleChangeBarcode = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        // Barcode alanında sadece rakam kabul et
        if (value != null) {
            value = value.toString().replace(/[^0-9]/g, '');
        }
        this.setState({barcode: value});
    }

    /**
     * Saves the given license to the server. Returns a Promise that resolves only on success.
     * State and dialog should be updated only after the server responds successfully.
     */
    saveLicenseToServer = (license, licenseSaveButtonRender) => {
        const isManualStyle = license.invoiceType === "MANUAL_ENTRY" || license.invoiceType === "FROM_DELIVERY_NOTE";
        if (isManualStyle && GeneralUtils.isNullOrEmpty(license.invoiceNumber)) {
            toast.warn("Invoice Number is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (isManualStyle && GeneralUtils.isNullOrEmpty(license.supplierName)) {
            toast.warn("Supplier is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (isManualStyle && GeneralUtils.isNullOrEmpty(license.invoiceDate)) {
            toast.warn("Invoice Date is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (isManualStyle && GeneralUtils.isNullOrEmpty(license.totalNet)) {
            toast.warn("Invoice Subtotal is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (isManualStyle && license.totalAmount == null) {
            toast.warn("Invoice Total is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType == "CSV" && (GeneralUtils.isNullOrEmpty(license.invoiceNumber) || GeneralUtils.isNullOrEmpty(license.supplierName))) {
            toast.warn("Please fill the Invoice Number and Supplier fields!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.purchaseOrderStatus == "CLOSED" && (!license.itemList || license.itemList.length == 0)) {
            toast.warn("Please add item!");
            return Promise.reject(new Error("VALIDATION"));
        }

        const licenseToSave = { ...license };
        if (licenseToSave.applyCurrentPriceFromBarcodeOnUpdate == null) {
            licenseToSave.applyCurrentPriceFromBarcodeOnUpdate = false;
        }
        if (licenseToSave.createReturnFromInvoiceShortage == null) {
            licenseToSave.createReturnFromInvoiceShortage = false;
        }
        // Only-on-DN dispositions applied on CLOSED confirm (request-only).
        if (licenseToSave.purchaseOrderStatus === 'CLOSED') {
            const resolutionPayload = buildInvoiceDnResolutionPayload(this.state.invoiceDnComparisonRows);
            if (resolutionPayload.length > 0) {
                licenseToSave.invoiceDnResolutions = resolutionPayload;
            } else {
                delete licenseToSave.invoiceDnResolutions;
            }
        } else {
            delete licenseToSave.invoiceDnResolutions;
        }
        // Display-only / UI-only fields must not break backend mapping.
        delete licenseToSave.assignedDeliveryNoteNo;
        delete licenseToSave.itemCount;
        delete licenseToSave.unsearchedActiveCount;
        delete licenseToSave.defaultCostPricePercentage;
        delete licenseToSave.createdReturn;
        delete licenseToSave.createdReturnFromWrongItem;
        delete licenseToSave.paymentList;
        delete licenseToSave.remainingAmount;
        const noneSelected = isDeliveryNoteNoneFlag(licenseToSave.deliveryNoteNone)
            || isDeliveryNoteNoneFlag(this.state.license?.deliveryNoteNone)
            || isNoneDeliveryNoteId(licenseToSave.assignedDeliveryNoteId)
            || isNoneDeliveryNoteId(this.state.license?.assignedDeliveryNoteId);
        licenseToSave.deliveryNoteNone = noneSelected;
        if (noneSelected) {
            licenseToSave.assignedDeliveryNoteId = DELIVERY_NOTE_NONE_ID;
        }
        if (Array.isArray(licenseToSave.itemList)) {
            licenseToSave.itemList = licenseToSave.itemList.map(item => {
                const cleaned = {...item};
                delete cleaned._rowNo;
                delete cleaned.highlightTableRowLightRed;
                return cleaned;
            });
        }
        licenseToSave.deliveryDate = this.toBackendDateTime(licenseToSave.deliveryDate);
        licenseToSave.invoiceDate = this.toBackendDateTime(licenseToSave.invoiceDate);
        // Do not rewrite createDate — backend owns it.

        const apiCall = !GeneralUtils.isNullOrEmpty(licenseToSave.id)
            ? this.purchaseOrderService.update(licenseToSave)
            : this.purchaseOrderService.create(licenseToSave);

        return apiCall
            .then((response) => {
                // Notification-only payloads have type but no id; real PO DTO has id.
                if (GeneralUtils.isNullOrEmpty(response)
                    || (!GeneralUtils.isNullOrEmpty(response.type) && GeneralUtils.isNullOrEmpty(response.id))) {
                    return Promise.reject(new Error("INVALID_RESPONSE"));
                }
                if (response.purchaseOrderStatus == "CLOSED") {
                    window.location.href = "#purchaseOrder";
                    return response;
                }
                this.setState({
                    licenseSaveButtonRender: licenseSaveButtonRender,
                    license: {
                        ...Object.assign({}, response),
                        deliveryNoteNone: isDeliveryNoteNoneFlag(response.deliveryNoteNone)
                            || isNoneDeliveryNoteId(response.assignedDeliveryNoteId)
                            || (isDeliveryNoteNoneFlag(this.state.license?.deliveryNoteNone)
                                && (GeneralUtils.isNullOrEmpty(response.assignedDeliveryNoteId)
                                    || isNoneDeliveryNoteId(response.assignedDeliveryNoteId))),
                        assignedDeliveryNoteId: (isDeliveryNoteNoneFlag(response.deliveryNoteNone)
                            || isNoneDeliveryNoteId(response.assignedDeliveryNoteId)
                            || (isDeliveryNoteNoneFlag(this.state.license?.deliveryNoteNone)
                                && (GeneralUtils.isNullOrEmpty(response.assignedDeliveryNoteId)
                                    || isNoneDeliveryNoteId(response.assignedDeliveryNoteId))))
                            ? DELIVERY_NOTE_NONE_ID
                            : (response.assignedDeliveryNoteId ?? null),
                        assignedDeliveryNoteNo: (isDeliveryNoteNoneFlag(response.deliveryNoteNone)
                            || isNoneDeliveryNoteId(response.assignedDeliveryNoteId))
                            ? 'NONE'
                            : (response.assignedDeliveryNoteNo || null)
                    },
                    licenseTemp: Object.assign({}, response)
                }, () => {
                    const dnId = this.state.license?.assignedDeliveryNoteId;
                    if (!isNoneDeliveryNoteId(dnId) && (!GeneralUtils.isNullOrEmpty(dnId) || this.state.assignedDeliveryNote)) {
                        if (this.state.assignedDeliveryNote
                            && Number(this.state.assignedDeliveryNote.id) === Number(dnId)) {
                            this.refreshInvoiceDnComparison();
                        } else {
                            this.loadAssignedDeliveryNoteForCompare(dnId);
                        }
                    }
                });
                return response;
            })
            .catch((err) => {
                // VALIDATION already toasted; INVALID_RESPONSE already shown via GeneralUtils.notification.
                if (err?.message !== 'VALIDATION' && err?.message !== 'INVALID_RESPONSE') {
                    toast.error("The request could not be sent to the server. Please try again.");
                }
                return Promise.reject(err);
            });
    };

    toBackendDateTime = (value) => {
        if (GeneralUtils.isNullOrEmpty(value)) {
            return value;
        }
        if (typeof value === 'number' && !Number.isNaN(value)) {
            const fromNumber = dayjs(value);
            return fromNumber.isValid() ? fromNumber.format('YYYY-MM-DDT00:00:00') : null;
        }
        const text = String(value).trim();
        if (text === 'Invalid Date') {
            return null;
        }
        if (/^\d{10,13}$/.test(text)) {
            const fromEpoch = dayjs(Number(text));
            return fromEpoch.isValid() ? fromEpoch.format('YYYY-MM-DDT00:00:00') : null;
        }
        // Already ISO-like
        if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
            const isoParsed = dayjs(text);
            return isoParsed.isValid() ? isoParsed.format('YYYY-MM-DDT00:00:00') : null;
        }
        const parsed = dayjs(text, ['DD/MM/YYYY', 'DD.MM.YYYY', 'YYYY-MM-DD'], true);
        return parsed.isValid() ? parsed.format('YYYY-MM-DDT00:00:00') : null;
    };

    savePurchaseOrderItem(licenseSaveButtonRender) {
        this.saveLicenseToServer(this.state.license, licenseSaveButtonRender).catch(() => {});
    }


    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm autocomplete="off">
                    <div className="settings-page__shell">
                        <div className="settings-page__panel">
                            {this.renderUploadImage()}
                            {this.renderPurchaseOrder()}
                        </div>
                    </div>
                </AvForm>

                <ModalConfirm
                    show={this.state.showCurrentPriceConfirmModal}
                    header="Confirm"
                    message="The prices of items in your invoice will be updated with the current prices. Do you want to continue?"
                    onOkClick={this.confirmCurrentPriceSelection}
                    onCancelClick={this.cancelCurrentPriceSelection}
                    ok="Yes"
                    cancel="No"
                />

                {this.state.loading && <Loading label="Processing, please wait..."/>}
            </div>
        );
    }

    setChecked = (name, value) => {
        let license = {...this.state.license}; // kopya al
        license[name] = value;

        this.setState({license}, () => {
            const updatedItemList = (this.state.license.itemList || []).map(item =>
                this.calculateFields({...item})
            );

            // hesaplanan listeyi tekrar state'e yaz
            this.setState(prevState => ({
                license: {
                    ...prevState.license,
                    itemList: updatedItemList
                }
            }));
        });


    };

    isDifferent() {
        let license = this.state.license;
        const licenseAmount = new Decimal(license?.totalAmount || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        const licenseNet = new Decimal(license?.totalNet || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        const itemsTotal = new Decimal(this.calculateItemsTotalPrice(license) || 0)
            .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

        if (license?.includeTax) {
            return !itemsTotal.equals(licenseAmount);
        } else {
            return !itemsTotal.equals(licenseNet);
        }
    }

    getActiveItems = (license = this.state.license) => {
        const items = Array.isArray(license?.itemList) ? license.itemList : [];
        return items.filter(item => item.status === "ACTIVE");
    };

    calculateItemsTotalPrice = (license = this.state.license) => {
        const itemList = Array.isArray(license?.itemList) ? license.itemList : [];
        return itemList.reduce((sum, item) => sum + (parseFloat(item.totalPrice) || 0), 0);
    };

    calculateTotalProfit = (license = this.state.license) => {
        return this.getActiveItems(license)
            .reduce((sum, item) => {
                const boxSize = parseFloat(item.boxSize) || 1;
                const deliveryQty = parseFloat(item.deliveryQuantity) || 1;
                const unitCost = parseFloat(item.unitCost) || 0;
                const salePrice = parseFloat(item.salePrice) || 0;
                const profitPerUnit = salePrice - unitCost;
                return sum + (profitPerUnit * deliveryQty * boxSize);
            }, 0);
    };


    setStateData = (data) => {
        const license = this.state.license;
        const existingList = Array.isArray(license.itemList) ? [...license.itemList] : [];
        const updatedList = Array.isArray(data) ? data : [];

        const isSameItem = (left, right) => {
            if (!left || !right) return false;
            if (left.id != null && right.id != null) {
                return left.id === right.id;
            }
            if (left.barcode && right.barcode) {
                return left.barcode === right.barcode;
            }
            return false;
        };

        const mergedList = existingList.map((item) => {
            const updatedItem = updatedList.find((candidate) => isSameItem(item, candidate));
            return updatedItem ? {...item, ...updatedItem} : item;
        });

        updatedList.forEach((item) => {
            const exists = mergedList.some((candidate) => isSameItem(candidate, item));
            if (!exists) {
                mergedList.push(item);
            }
        });

        this.setState({
            license: {
                ...license,
                itemList: mergedList
            }
        }, () => this.refreshInvoiceDnComparison());
    }


    refreshDataTable = () => {
        this.closeDisplayDialog();
        this.refDataTable.refresh();
    }


    deleteInvoice = (data) => {
        if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            this.purchaseOrderService.delete(this.state.license.id)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        window.location.href = "#purchaseOrder";
                    }


                });
        }
    }
    deleteItemData = () => {
        const {license} = this.state;

        if (license.purchaseOrderStatus !== "CLOSED") {
            const deleteId = this.refModelSave.getDeleteId();
            if (!deleteId) return;

            const updatedItemList = license.itemList.filter(item => item.id !== deleteId);
            const updatedLicense = { ...license, itemList: updatedItemList };

            this.saveLicenseToServer(updatedLicense, true)
                .then(() => this.closeDisplayDialog())
                .catch(() => {});
        }
    }


    convertToDto = async (response) => {
        const data = {
            itemBssId: response.bssId,
            barcode: response.barcode,
            itemName: response.name,
            itemSize: response.quantity,
            taxRate: response.taxRate ?? response.departmentTaxRate,
            weighable: response.weighable,
            deliveryQuantity: 1,
            boxPrice: response.costPrice,
            oldPrice: response.price,
            currentBoxPrice: response.costPrice,
            currentBoxSize: (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null,
            status: "ACTIVE",
            barcodeType: response.barcodeType,
            barcodeDigit: response.barcodeDigit,
            codeLength: response.codeLength,
            salePrice: null,
            profitMargin: response.profitMargin,
            recommendedSalePrice: response.recommendedSalePrice,
            itemUnitMeasure: response.unit,
            boxUnitMeasure: response.boxUnit,
            departmentId: response.departmentId,
            barcodeIsSearched: true,
            tillPriceCalculationMethod: this.state.license.tillPriceCalculationMethod
        };

        // boxSize sadece 0 veya 1 değilse ata
        if (response.boxQuantity != null && response.boxQuantity !== 0 && response.boxQuantity !== 1) {
            data.boxSize = response.boxQuantity;
        } else if (data.boxSize == null && response.boxQuantity != null) {
            data.boxSize = response.boxQuantity;
        }

        // minStock
        if (response.minStock != null && response.minStock !== 0) {
            data.minStock = response.minStock;
        } else {
            data.minStock = await this.getDefaultMinStock();
        }

        // maxStock
        if (response.maxStock != null && response.maxStock !== 0) {
            data.maxStock = response.maxStock;
            data.maxOrjStock = response.maxStock;
        }

        return data;
    };


    convertProductDTOToItemDto = async (data, response) => {
        data.itemBssId = response.bssId;
        data.departmentId = response.departmentId;
        data.taxRate = (response.taxRate ?? response.departmentTaxRate);
        data.oldPrice = response.price;
        data.currentBoxPrice = response.costPrice;
        data.currentBoxSize = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
        data.status = "ACTIVE";
        data.barcodeType = response.barcodeType;
        data.barcodeDigit = response.barcodeDigit;
        data.codeLength = response.codeLength;
        data.itemName = response.name;
        data.itemSize = response.quantity;
        data.itemUnitMeasure = response.unit;
        // boxSize sadece 0 veya 1 değilse ata
        if (response.boxQuantity != null && response.boxQuantity !== 0 && response.boxQuantity !== 1) {
            data.boxSize = response.boxQuantity;
        } else if (data.boxSize == null && response.boxQuantity != null) {
            data.boxSize = response.boxQuantity;
        }

        data.boxUnitMeasure = response.boxUnit;


        data.profitMargin = (response.profitMargin != null && response.profitMargin !== 0 && response.profitMargin !== 40)
            ? response.profitMargin
            : ((response.departmentProfitMargin != null && response.departmentProfitMargin !== 0 && response.departmentProfitMargin !== 40)
                ? response.departmentProfitMargin
                : await this.getDefaultProfitMargin());

        data.weighable = response.weighable;
        if (response.minStock != null && response.minStock !== 0) {
            data.minStock = response.minStock;
        } else {
            data.minStock = await this.getDefaultMinStock();
        }

        if (response.maxStock != null && response.maxStock !== 0) {
            data.maxStock = response.maxStock;
            data.maxOrjStock = response.maxStock;
        } else {
            data.maxOrjStock = null;
        }

        data.barcodeIsSearched = true;


        return data;


    }
    getDefaultProfitMargin = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.profitMargin?? 40;
                }
                return 40;
            });
    };
    getDefaultMinStock = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.minStock ?? null; // response.minStock varsa al, yoksa null
                }
                return null;
            });
    };
    /** Listeyi güncelle - save/close yapmadan (barcode search sonrası sync için) */
    updatePurchaseOrderItemFieldsOnly = (data) => {
        let license = this.state.license;
        const updatedItemList = [...(license['itemList'] || [])];
        let existingIndex = updatedItemList.findIndex(item => item.id === data.id);
        if (existingIndex == -1) {
            existingIndex = updatedItemList.findIndex(item => item.barcode === data.barcode);
        }
        if (existingIndex !== -1) {
            updatedItemList[existingIndex] = {...updatedItemList[existingIndex], ...data};
        }
        this.setState({ license: { ...license, itemList: updatedItemList } }, () => {
            this.refreshInvoiceDnComparison();
        });
    };

    /** Yeni item (id yok): item'ı itemList'e ekleyip PO'yu backend update ile gönderir, dialog kapatılır. */
    saveNewItemAndClose = (itemData) => {
        const license = this.state.license;
        const updatedItemList = [...(license.itemList || [])];
        updatedItemList.push({...itemData, status: itemData.status || 'ACTIVE', shouldWarnUser: itemData.shouldWarnUser === true});
        const updatedLicense = {...license, itemList: updatedItemList};
        this.saveLicenseToServer(updatedLicense, true)
            .then(() => this.closeDisplayDialog())
            .catch(() => {});
    };

    /** Item'ı backend'e tek tek gönderir; başarıda listeyi DB'den çekip ekranda son hali gösterilir. */
    updatePurchaseOrderItem = (data) => {
        if (GeneralUtils.isNullOrEmpty(data?.id)) {
            this.saveNewItemAndClose(data);
            return;
        }
        const licenseId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            return;
        }
        this.purchaseOrderService.updateItems(data)
            .then((itemResponse) => {
                if (GeneralUtils.isNullOrEmpty(itemResponse) || !GeneralUtils.isNullOrEmpty(itemResponse.type)) {
                    return;
                }
                return this.purchaseOrderService.findById(licenseId);
            })
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    return;
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense)
                }, () => {
                    this.refreshInvoiceDnComparison();
                    this.closeDisplayDialog();
                });
            })
            .catch(() => {});
    }

    closePurchaseOrderItemAndNextUnmatched = (data) => {
        if (this.state.processButton == "new") {
            let license = this.state.license;
            const updatedItemList = license['itemList'];

            // 🔹 Sadece aktif ürünleri filtrele
            //const activeItems = updatedItemList.filter(item => item.status === "ACTIVE");
            const activeItems = updatedItemList;

            // 🔹 id veya barcode ile aktif listede mevcut item'ı bul
            let existingIndex = activeItems.findIndex(item => item.id === data.id);
            if (existingIndex === -1) {
                existingIndex = activeItems.findIndex(item => item.barcode === data.barcode);
            }

            if (existingIndex !== -1) {
                const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
                updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
            } else {
                updatedItemList.push(data);
            }

            license['itemList'] = updatedItemList;

            this.setState({license}, () => {

                // sıradaki aktif item’lerden barcodeIsSearched == true && itemBssId == null olanı bul
                const nextNew = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === true && item.itemBssId == null);

                if (nextNew) {
                    this.onDataSelect(nextNew, false);
                } else {
                    this.closeDisplayDialog();
                }
            });
        } else {
            let license = this.state.license;
            const updatedItemList = license['itemList'];
            //const activeItems = updatedItemList.filter(item => item.status === "ACTIVE");
            const activeItems = updatedItemList;

            let existingIndex = activeItems.findIndex(item => item.id === data.id);
            if (existingIndex === -1) {
                existingIndex = activeItems.findIndex(item => item.barcode === data.barcode);
            }

            if (existingIndex !== -1) {
                const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
                updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
            } else {
                updatedItemList.push(data);
            }

            license['itemList'] = updatedItemList;

            this.setState({license}, () => {

                const nextUnmatched = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === false || item.barcodeIsSearched == null);

                if (nextUnmatched) {
                    this.onDataSelect(nextUnmatched, false);
                } else {
                    this.closeDisplayDialog();
                }
            });
        }
    };

    openNextItem = (data) => {
        let license = this.state.license;
        const updatedItemList = license['itemList'];
        const activeItems = updatedItemList;
        const { processButton, itemDialogOpenedFromItem } = this.state;

        let existingIndex = activeItems.findIndex(item => item.id === data.id);

        if (existingIndex !== -1) {
            const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
            updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
        } else {
            updatedItemList.push(data);
        }

        license['itemList'] = updatedItemList;

        this.setState({license}, () => {

            if (itemDialogOpenedFromItem) {
                const nextIndex = existingIndex + 1;
                if (nextIndex < activeItems.length) {
                    this.onDataSelect(activeItems[nextIndex], true);
                } else {
                    this.closeDisplayDialog();
                }
                return;
            }

            let nextRow = null;
            if (processButton === "new") {
                nextRow = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === true && item.itemBssId == null);
            } else {
                nextRow = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === false || item.barcodeIsSearched == null);
            }

            if (nextRow) {
                this.onDataSelect(nextRow, false);
            } else {
                this.closeDisplayDialog();
            }
        });
    };

    closePurchaseOrderItemAndNext = (data) => {
        let license = this.state.license;
        const updatedItemList = license['itemList'];

        // 🔹 Sadece aktif ürünleri filtrele
        //const activeItems = updatedItemList.filter(item => item.status === "ACTIVE");
        const activeItems = updatedItemList;

        // 🔹 id veya barcode ile aktif listede mevcut item'ı bul
        let existingIndex = activeItems.findIndex(item => item.id === data.id);
        if (existingIndex === -1) {
            existingIndex = activeItems.findIndex(item => item.barcode === data.barcode);
        }

        if (existingIndex !== -1) {
            const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
            updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
        } else {
            updatedItemList.push(data);
        }

        license['itemList'] = updatedItemList;

        this.setState({license}, () => {

            const nextIndex = existingIndex + 1;
            if (nextIndex < activeItems.length) {
                this.onDataSelect(activeItems[nextIndex], true);
            } else {
                this.closeDisplayDialog();
            }
        });
    };

    /** Item'ı backend'e tek tek gönderir; başarıda listeyi DB'den çekip sıradaki unmatched item'a geçer. */
    updatePurchaseOrderItemAndNextUnmatched = (data) => {
        if (GeneralUtils.isNullOrEmpty(data?.id)) {
            this.saveNewItemAndClose(data);
            return;
        }
        const { license, processButton } = this.state;
        const licenseId = license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            return;
        }
        this.purchaseOrderService.updateItems(data)
            .then((itemResponse) => {
                if (GeneralUtils.isNullOrEmpty(itemResponse) || !GeneralUtils.isNullOrEmpty(itemResponse.type)) {
                    return;
                }
                return this.purchaseOrderService.findById(licenseId);
            })
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    return;
                }
                const activeItems = freshLicense.itemList || [];
                const idx = activeItems.findIndex(item => item.id === data.id) >= 0
                    ? activeItems.findIndex(item => item.id === data.id)
                    : activeItems.findIndex(item => item.barcode === data.barcode);
                let nextItem = null;
                if (processButton == "new") {
                    nextItem = activeItems
                        .slice(idx + 1)
                        .find(item => item.barcodeIsSearched === true && item.itemBssId == null);
                } else {
                    nextItem = activeItems
                        .slice(idx + 1)
                        .find(item => item.barcodeIsSearched === false || item.barcodeIsSearched == null);
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense)
                }, () => {
                    this.refreshInvoiceDnComparison();
                    if (nextItem) {
                        this.onDataSelect(nextItem, false);
                    } else {
                        this.closeDisplayDialog();
                    }
                });
            })
            .catch(() => {});
    };

    /** Item'ı backend'e tek tek gönderir; başarıda listeyi DB'den çekip sıradaki item'a geçer. */
    updatePurchaseOrderItemAndNext = (data) => {
        if (GeneralUtils.isNullOrEmpty(data?.id)) {
            this.saveNewItemAndClose(data);
            return;
        }
        const { license } = this.state;
        const licenseId = license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            return;
        }
        this.purchaseOrderService.updateItems(data)
            .then((itemResponse) => {
                if (GeneralUtils.isNullOrEmpty(itemResponse) || !GeneralUtils.isNullOrEmpty(itemResponse.type)) {
                    return;
                }
                return this.purchaseOrderService.findById(licenseId);
            })
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    return;
                }
                const activeItems = freshLicense.itemList || [];
                const idx = activeItems.findIndex(item => item.id === data.id) >= 0
                    ? activeItems.findIndex(item => item.id === data.id)
                    : activeItems.findIndex(item => item.barcode === data.barcode);
                const nextItem = activeItems[idx + 1];
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense)
                }, () => {
                    this.refreshInvoiceDnComparison();
                    if (nextItem) {
                        this.onDataSelect(nextItem, true);
                    } else {
                        this.closeDisplayDialog();
                    }
                });
            })
            .catch(() => {});
    };


    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    /** Sadece order'ı DB'den çekip listeyi günceller ve dialog'u kapatır (conflict'te başka item seçildiğinde revert'i ezmemek için). */
    refreshOrderAndClose = () => {
        const licenseId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            this.closeDisplayDialog();
            return;
        }
        this.purchaseOrderService.findById(licenseId)
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    this.closeDisplayDialog();
                    return;
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense)
                }, () => {
                    this.refreshInvoiceDnComparison();
                    this.closeDisplayDialog();
                });
            })
            .catch(() => this.closeDisplayDialog());
    }


    licenseSaveButtonRender = () => {
        this.setState({licenseSaveButtonRender: true});
    }

    setData = (data) => {
        this.setState({
            license: data,
            licenseTemp: Object.assign({}, data),
            licenseSaveButtonRender: false,
            renderExtraDataDeleteButton: false
        });

    }


    confirmInvoice = (fullConfirmInvoice) => {
        if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.itemList.length == 0) {
                return toast.warn("Please add item!");
            } else {
                const itemList = this.state.license.itemList;
                let checkfields = false;
                let message = "";

                const missingFields = [];

                if (GeneralUtils.isNullOrEmpty(this.state.license.invoiceNumber)) {
                    missingFields.push("Invoice Number");
                }
                if (GeneralUtils.isNullOrEmpty(this.state.license.supplierName)) {
                    missingFields.push("Supplier");
                }
                if (GeneralUtils.isNullOrEmpty(this.state.license.invoiceDate)) {
                    missingFields.push("Invoice Date");
                }
                if (GeneralUtils.isNullOrEmpty(this.state.license.totalNet)) {
                    missingFields.push("Invoice Subtotal");
                }
                if (this.state.license.totalAmount == null) {
                    missingFields.push("Invoice total");
                }

                if (missingFields.length > 0) {
                    return toast.warn(`Please fill the required fields: ${missingFields.join(", ")}`);
                }

                if (this.isUploadInvoice() && !this.hasDeliveryNoteChoice()) {
                    return toast.warn('Please select a Delivery Note or NONE before confirming');
                }

                const fieldsMeta = {
                    barcode: "Barcode",
                    itemName: "Name",
                    itemSize: "Item Size",
                    itemUnitMeasure: "Unit Measure",
                    taxRate: "Tax Rate",
                    totalPrice: "Total Cost",
                    deliveryQuantity: "Delivery Qty",
                    boxPrice: "Box Cost",
                    boxSize: "Box Qty",
                    profitMargin: "Profit Margin",
                    salePrice: "Sale Price",
                    departmentId: "Department"
                };

                // 🔹 Ana fonksiyon — invoice'ı kapatır; flag set ise backend confirm içinde Open Return oluşturur
                const closeInvoice = (createReturnFromShortage = false) => {
                    let license = this.state.license;
                    license['purchaseOrderStatus'] = fullConfirmInvoice === true ? "CLOSED" : "PARTIAL_CLOSED";
                    license['createReturnFromInvoiceShortage'] = !!createReturnFromShortage;
                    this.setState({license}, () => this.savePurchaseOrderItem(false));
                };

                if (fullConfirmInvoice) {
                    const inactiveItems = itemList.filter(item => item.status !== "ACTIVE");
                    const activeItems = itemList.filter(item => item.status === "ACTIVE");

                    // 🔹 Önce ACTIVE item'ları kontrol et
                    for (const item of activeItems) {
                        if (item.barcodeIsSearched === false || item.barcodeIsSearched == null) {
                            message = `This barcode '${item.itemName}' has not been searched.`;
                            checkfields = true;
                            break;
                        }

                        for (const field in fieldsMeta) {
                            if (field === "taxRate") {
                                if (item[field] == null) {
                                    message = `Please fill the field '${fieldsMeta[field]}' for item: '${item.itemName}'.`;
                                    checkfields = true;
                                    break;
                                }
                            } else {
                                if (GeneralUtils.isNullOrEmpty(item[field])) {
                                    message = `Please fill the field '${fieldsMeta[field]}' for item: '${item.itemName}'.`;
                                    checkfields = true;
                                    break;
                                }
                            }
                        }
                        if (checkfields) break;
                    }

                    // 🔹 Eğer eksik yoksa ama pasif kayıt varsa kullanıcıya sor
                    if (!checkfields && inactiveItems.length > 0) {
                        const inactiveCount = inactiveItems.length;
                        const inactiveNames =
                            inactiveItems
                                .slice(0, 5)
                                .map(i => i.itemName)
                                .join(", ") + (inactiveCount > 5 ? "..." : "");

                        const confirmMessage = `There are ${inactiveCount} ignored items (${inactiveNames}). Do you still want to continue?`;

                        this.setState({
                            showConfirmModal: true,
                            confirmMessage,
                            confirmAction: () => {
                                this.setState({showConfirmModal: false}, () => {
                                    this.promptInvoiceShortageThenConfirm(closeInvoice);
                                });
                            }
                        });

                        return; // durdur, kullanıcı kararı bekle
                    }
                } else {
                    // PARTIAL confirm: sadece barcode doluysa diğer alanlara bak
                    for (const item of itemList) {
                        if (GeneralUtils.isNullOrEmpty(item.barcode)) continue;

                        for (const field in fieldsMeta) {
                            if (field === "barcode") continue;

                            if (field === "taxRate") {
                                if (item[field] == null) {
                                    message = `Please fill the field '${fieldsMeta[field]}' for item: '${item.itemName}'.`;
                                    checkfields = true;
                                    break;
                                }
                            } else {
                                if (GeneralUtils.isNullOrEmpty(item[field])) {
                                    message = `Please fill the field '${fieldsMeta[field]}' for item: '${item.itemName}'.`;
                                    checkfields = true;
                                    break;
                                }
                            }
                        }
                        if (checkfields) break;
                    }
                }

                if (checkfields) {
                    return toast.warn(message);
                }

                if (fullConfirmInvoice) {
                    this.promptInvoiceShortageThenConfirm(closeInvoice);
                } else {
                    this.promptNoneDeliveryNoteStockWarningThen(closeInvoice, false);
                }
            }
        }
    };

    /**
     * Full Confirm: if invoice qty exceeds Net DN (delivered − waste) for same barcode, show dialog + checkbox.
     * Only when checkbox is checked, update sends createReturnFromInvoiceShortage for PurchaseOrderService.
     */
    promptInvoiceShortageThenConfirm = (closeInvoiceFn) => {
        const hasLinkedDn = this.isUploadInvoice()
            && !GeneralUtils.isNullOrEmpty(this.state.license?.assignedDeliveryNoteId)
            && !isNoneDeliveryNoteId(this.state.license?.assignedDeliveryNoteId)
            && this.state.assignedDeliveryNote;
        if (!hasLinkedDn) {
            this.promptNoneDeliveryNoteStockWarningThen(closeInvoiceFn, false);
            return;
        }
        const rows = buildInvoiceDeliveryNoteComparisonRows(
            this.state.license?.itemList,
            this.state.assignedDeliveryNote?.itemList,
            this.state.invoiceDnDispositions
        );
        this.setState({invoiceDnComparisonRows: rows});
        const shortageRows = getInvoiceShortageRows(rows);
        if (!shortageRows.length) {
            this.runInvoiceTotalMismatchThenClose(closeInvoiceFn, false);
            return;
        }
        this.setState({
            showConfirmModal: true,
            confirmMessage: buildInvoiceShortageConfirmMessage(rows),
            showCreateReturnShortageCheckbox: true,
            createReturnFromShortageChecked: true,
            confirmAction: () => {
                const createReturn = !!this.state.createReturnFromShortageChecked;
                this.setState({
                    showConfirmModal: false,
                    showCreateReturnShortageCheckbox: false
                }, () => {
                    this.runInvoiceTotalMismatchThenClose(closeInvoiceFn, createReturn);
                });
            }
        });
    };

    /**
     * NONE selected: warn that stock will be updated from the invoice
     * (Delivery Note confirm also updates stock when a real DN is used).
     */
    promptNoneDeliveryNoteStockWarningThen = (closeInvoiceFn, createReturnFromShortage) => {
        if (this.isUploadInvoice() && this.isDeliveryNoteNoneSelected()) {
            this.setState({
                showConfirmModal: true,
                confirmMessage:
                    'NONE is selected (no Delivery Note). Stock will be updated from this invoice on confirm. '
                    + 'If you had selected a Delivery Note, stock would already be (or would be) updated when that Delivery Note is confirmed — not again here. Continue?',
                confirmAction: () => {
                    this.setState({showConfirmModal: false}, () => {
                        this.runInvoiceTotalMismatchThenClose(closeInvoiceFn, createReturnFromShortage);
                    });
                }
            });
            return;
        }
        this.runInvoiceTotalMismatchThenClose(closeInvoiceFn, createReturnFromShortage);
    };

    runInvoiceTotalMismatchThenClose = (closeInvoiceFn, createReturnFromShortage) => {
        const itemList = this.state.license?.itemList || [];
        let totalCostDecimal = new Decimal(0);
        for (const item of itemList.filter(item => item.status === "ACTIVE")) {
            totalCostDecimal = totalCostDecimal.plus(new Decimal(item.totalPrice || 0));
        }

        totalCostDecimal = totalCostDecimal.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

        const licenseAmount = new Decimal(this.state.license?.totalAmount || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        const licenseNet = new Decimal(this.state.license?.totalNet || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

        let needsConfirmation = false;
        let confirmMessage = "";

        if (this.state.license?.includeTax) {
            if (!totalCostDecimal.equals(licenseAmount)) {
                needsConfirmation = true;
                confirmMessage = `Invoice Total (£${licenseAmount}) and items Total (£${totalCostDecimal}) are different! Are you sure to continue?`;
            }
        } else {
            if (!totalCostDecimal.equals(licenseNet)) {
                needsConfirmation = true;
                confirmMessage = `Invoice Subtotal (£${licenseNet}) and items Total (£${totalCostDecimal}) are different! Are you sure to continue?`;
            }
        }

        const finish = () => closeInvoiceFn(createReturnFromShortage);

        if (needsConfirmation) {
            this.setState({
                showConfirmModal: true,
                confirmMessage,
                confirmAction: finish
            });
        } else {
            finish();
        }
    };

    showInvoiceDeleteConfirmDialog = () => {
        this.setState({
            displayShowInvoiceDialog: true,
            noticeResponse: "Are you sure to delete invoice?",
        });
    }

    clearData = () => {
        let obj = Object.assign({}, defaultLicense);
        this.setState({license: obj, renderExtraDataDeleteButton: false});
    }


    __handleChange = async (e) => {
        const {name, value: rawValue, parsedValue} = e.target;
        const value = parsedValue !== undefined ? parsedValue : rawValue;

        if (name == "tillPriceCalculationMethod") {
            if (value === "CURRENT_PRICE") {
                this.setState({
                    showCurrentPriceConfirmModal: true,
                    pendingTillPriceCalculationMethod: value
                });
                return;
            }
            let license = {...this.state.license}; // kopya al
            license[name] = value;

            this.setState({license}, () => {
                const updatedItemList = (license.itemList || []).map(item => {
                    // item = { ...item, tillPriceCalculationMethod: value };
                    return this.calculateFields(item);
                });

                this.setState(prevState => ({
                    license: {
                        ...prevState.license,
                        itemList: updatedItemList
                    }
                }));
            });
        } else {
            this.setState(prev => {
                let updatedLicense = {
                    ...prev.license,
                    [name]: value,
                    ...(name === "barcode"
                        ? {
                            barcodeIsSearched: false,
                            ItemBssId: null
                        }
                        : {})

                };

                return {license: updatedLicense};
            });
        }
    };

    confirmCurrentPriceSelection = async () => {
        const value = this.state.pendingTillPriceCalculationMethod || "CURRENT_PRICE";
        this.setState({
            showCurrentPriceConfirmModal: false,
            pendingTillPriceCalculationMethod: null
        });

        const approved = this.checkSupplierApproved();
        if (!approved) {
            toast.warn("Please approve supplier to continue");
            return;
        }

        const license = {
            ...this.state.license,
            tillPriceCalculationMethod: value,
            applyCurrentPriceFromBarcodeOnUpdate: true
        };
        const updatedItemList = (license.itemList || []).map(item => this.calculateFields(item));
        const updatedLicense = {
            ...license,
            itemList: updatedItemList
        };

        this.setState({license: updatedLicense, loading: true});
        try {
            await this.saveLicenseToServer(updatedLicense, false);
        } finally {
            this.setState({loading: false});
        }
    }

    cancelCurrentPriceSelection = () => {
        this.setState(prevState => ({
            showCurrentPriceConfirmModal: false,
            pendingTillPriceCalculationMethod: null,
            tillPriceMethodSelectKey: (prevState.tillPriceMethodSelectKey || 0) + 1
        }));
    }

    _handleKeyDown = (e) => {
        if (e.target.name === 'barcode') {
            const allowedKeys = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Enter'];
            const isDigit = e.key.length === 1 && /[0-9]/.test(e.key);
            const isAllowedSpecial = allowedKeys.includes(e.key);
            const isShortcut = e.ctrlKey || e.metaKey;
            if (!isDigit && !isAllowedSpecial && !isShortcut) {
                e.preventDefault();
                return;
            }
        }
        if (e.key === 'Enter') {
            this.findByBarcode();
        }
    }

    searchProduct = (event) => {
        setTimeout(() => {
            this.productService.searchProductsByName(event.query).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({filteredProducts: response});
                } else {
                    this.setState({filteredProducts: []});
                }


            });
        }, 250);
    }

    searchByBarcode = async (data) => {
        if (!GeneralUtils.isNullOrEmpty(data) && !GeneralUtils.isNullOrEmpty(data.barcode)) {
            try {
                const response = await this.productService.findProductByBarcodeWithDepos(data.barcode);

                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.refreshDepartmentListIfMissing(response.departmentId);
                    data = await this.convertProductDTOToItemDto(data, response);
                } else {
                    data.barcodeIsSearched = true;
                    data.itemBssId = null;
                    this.setState({}, () => {
                        //toast.warn("Barcode not Found");
                    });


                }
            } catch (error) {
                console.error("Barcode search error", error);
            }
        }
        return data;
    }


    findByBarcode() {
        if (!GeneralUtils.isNullOrEmpty(this.state.barcode)) {
            this.productService.findProductByBarcodeWithDepos(this.state.barcode)
                .then(async (response) => {

                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.refreshDepartmentListIfMissing(response.departmentId);
                        const data = await this.convertToDto(response);
                        this.updatePurchaseOrderItem(data);
                    } else {
                        this.setState({
                            barcode: '', selectedProduct: null, productId: null, productList: []
                        });
                        this.setState({}, () => {
                            //return toast.warn("Barcode not Found!");
                        });
                    }
                });
        }
        this.setState({barcode: ''});

    }

    refreshDepartmentListIfMissing = (departmentId) => {
        if (GeneralUtils.isNullOrEmpty(departmentId)) {
            return;
        }
        const exists = (this.state.departmentList || []).some((department) => department.id === departmentId);
        if (!exists) {
            this.departmentService.findAll().then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({departmentList: response});
                }
            });
        }
    }

    importCsv(id) {
        let image = this.refUploadInputCsv.files;
        if (!(GeneralUtils.isNullOrEmpty(image) || GeneralUtils.isNullOrEmpty(image.length))) {
            this.setState({loading: true});
            let formData = new FormData();
            if (!GeneralUtils.isNullOrEmpty(image) && !GeneralUtils.isNullOrEmpty(image.length)) {
                formData.append("file", image[0]);
                this.purchaseOrderService.importCsv(id, formData).then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.departmentService.findAll().then(responseDepartment => this.setState({departmentList: responseDepartment}));
                        if (this.refUploadInputCsv?.clear) {
                            this.refUploadInputCsv.clear();
                        }

                        let responseObject = Object.assign({}, response);
                        let responseObjectTemp = Object.assign({}, response);
                        this.setState({
                            //licenseSaveButtonRender: true,
                            license: responseObject,
                            loading: false,
                            licenseTemp: responseObjectTemp
                        }, () => {
                            this.setAllRowsEditable();
                        });

                    } else {
                        this.setState({
                            loading: false,
                        }, () => {
                        });
                    }

                });

            }
        } else {
            return toast.warn("Upload a csv file");
        }

    }

    getInvoiceStatusLabel = () => {
        const status = this.state.license?.purchaseOrderStatus;
        if (GeneralUtils.isNullOrEmpty(status)) {
            return '';
        }
        const match = (PURCHASE_ORDER_STATUS || []).find(el => el.value === status);
        return match?.name || status;
    };

    getInvoiceStatusBadgeTone = () => {
        const status = this.state.license?.purchaseOrderStatus;
        if (status === 'CLOSED') {
            return 'closed';
        }
        if (status === 'PARTIAL_CLOSED') {
            return 'partial';
        }
        if (status === 'INVOICE' || !status) {
            return 'open';
        }
        return 'other';
    };

    getInvoiceDetailSectionTitle = () => {
        const statusLabel = this.getInvoiceStatusLabel();
        if (!statusLabel) {
            return 'Invoice Detail';
        }
        const tone = this.getInvoiceStatusBadgeTone();
        return (
            <>
                <span>Invoice Detail</span>
                <span className={`invoice-status-badge invoice-status-badge--${tone}`} title={`Status: ${statusLabel}`}>
                    <span className="invoice-status-badge__dot" aria-hidden="true"/>
                    {statusLabel}
                </span>
            </>
        );
    };

    isInvoiceHeaderEditable() {
        return (
            this.state.licenseSaveButtonRender &&
            this.state.license.purchaseOrderStatus !== "CLOSED" &&
            this.state.license.purchaseOrderStatus !== "PARTIAL_CLOSED"
        );
    }

    renderSupplierNameField() {
        return (
            <div className="invoice-detail-field invoice-detail-field--supplier">
                <AvGroup className="mb-0">
                    <Label for="tradingName">
                        <Translate contentKey="productGroup.tradingName">Supplier</Translate>
                        <span style={{color: 'red'}}> (*)</span>
                    </Label>

                    <div className="invoice-detail-supplier-input">
                        <AvField
                            type="text"
                            name="supplierName"
                            className="form-control"
                            disabled={this.isManualStyleInvoice() || this.state.license.invoiceType == "CSV" ? true : !this.state.licenseSaveButtonRender || this.state.license.supplierApproved || !GeneralUtils.isNullOrEmpty(this.state.license.supplierId)}
                            value={this.state.license.supplierName}
                            onChange={this.__handleChange}
                        />

                        <div className="invoice-detail-supplier-input__actions">
                            {!(!this.state.licenseSaveButtonRender || this.state.license.supplierApproved || !GeneralUtils.isNullOrEmpty(this.state.license.supplierId)) &&
                                <i
                                    className="pi pi-search"
                                    style={{
                                        cursor: this.state.licenseSaveButtonRender ? "pointer" : "not-allowed",
                                        color: this.state.licenseSaveButtonRender ? "#000" : "#ccc",
                                    }}
                                    onClick={() => {
                                        if (!this.state.licenseSaveButtonRender) return;
                                        this.setState({displayDialogFilter: true});
                                    }}
                                />
                            }

                            {!GeneralUtils.isNullOrEmpty(this.state.license.supplierId) ? (
                                <span className="invoice-detail-supplier-badge invoice-detail-supplier-badge--ok">
                                    <i className="pi pi-check"/>
                                </span>
                            ) : (
                                <span className="invoice-detail-supplier-badge invoice-detail-supplier-badge--new blinking-badge">
                                    NEW
                                </span>
                            )}
                        </div>
                    </div>

                    {this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.invoiceNumber != "ERROR" &&
                        !this.checkSupplierApproved() &&
                        <div className="invoice-detail-approve-wrap">
                            <Button
                                color="outline-primary"
                                size="sm"
                                className="settings-page__btn--save settings-page__btn--wrap invoice-detail-approve-btn"
                                onClick={() => {
                                    let license = this.state.license;

                                    if (GeneralUtils.isNullOrEmpty(license.supplierName)
                                    ) {
                                        return toast.warn("Please fill the supplier field!");
                                    } else {
                                        this.purchaseOrderService.approveSupplierAndProcessAgain(license)
                                            .then((response) => {
                                                if (
                                                    !GeneralUtils.isNullOrEmpty(response) &&
                                                    GeneralUtils.isNullOrEmpty(response.type)
                                                ) {
                                                    this.setState({
                                                        license: response,
                                                        licenseTemp: response
                                                    }, () => {
                                                        this.setAllRowsEditable();
                                                    });
                                                }
                                            });
                                    }

                                }}
                            >
                                <Translate contentKey="entity.action.add">Approve Supplier</Translate>
                            </Button>
                        </div>
                    }
                </AvGroup>
            </div>
        );
    }

    renderInvoiceDateField() {
        return (
            <div className="invoice-detail-field invoice-detail-field--date">
                <AvGroup className="mb-0">
                    <Label for="invoiceDate">
                        <Translate contentKey="merchantBranch.updateDate">Invoice Date</Translate>
                        <span style={{color: 'red'}}> (*)</span>
                    </Label>
                    <div className="invoice-detail-date-input">
                        <DateInput
                            name="invoiceDate"
                            onChange={this.__handleChange}
                            format={"DD/MM/YYYY"}
                            disabled={!this.isInvoiceHeaderEditable()}
                            value={this.state.license.invoiceDate}/>
                    </div>
                </AvGroup>
            </div>
        );
    }

    renderInvoiceNumberField() {
        return (
            <div className="invoice-detail-field">
                <AvGroup className="mb-0">
                    <Label for="remainingDaysText">
                        <Translate contentKey="merchantBranch.remainingDaysText">Invoice Number</Translate>
                        <span style={{color: 'red'}}> (*)</span>
                    </Label>
                    <AvField
                        type="text"
                        className="form-control"
                        name="invoiceNumber"
                        disabled={!this.isInvoiceHeaderEditable()}
                        value={this.state.license.invoiceNumber}
                        onChange={this.__handleChange}/>
                </AvGroup>
            </div>
        );
    }

    renderTillPriceCalculatorField() {
        return (
            <div className="invoice-detail-field">
                <AvGroup className="mb-0">
                    <Label for="firstName">
                        <Translate contentKey="productfirstName">Invoice Till Price Calculator</Translate>
                    </Label>
                    <AvField
                        key={`till-price-calculation-${this.state.tillPriceMethodSelectKey}`}
                        type="select"
                        className="form-control"
                        name="tillPriceCalculationMethod"
                        disabled={!this.isInvoiceHeaderEditable()}
                        value={this.state.license.tillPriceCalculationMethod || "NEAREST_9"}
                        onChange={this.__handleChange}
                    >
                        {INVOICE_TILL_PRICE_CALCULATION_METHOD.map(element => (
                            <option value={element.value} key={element.value}>
                                {element.name}
                            </option>
                        ))}
                    </AvField>
                </AvGroup>
            </div>
        );
    }

    renderTillUserField() {
        return (
            <div className="invoice-detail-field">
                <AvGroup className="mb-0">
                    <Label for="mobilePhone">
                        <Translate contentKey="contactManagement.mobilePhone">Invoice Till User</Translate>
                    </Label>
                    <AvField
                        type="select"
                        disabled={!(this.state.licenseSaveButtonRender && !GeneralUtils.isNullOrEmpty(this.state.license.id) && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                        className="form-control"
                        name="printQueueTillUserBssId"
                        value={this.state.license.printQueueTillUserBssId}
                        onChange={this.__handleChange}>
                        <option value="" key=''>
                            Select
                        </option>
                        {this.state.tillUserList.map(element => (
                            <option value={element.bssId} key={element.bssId}>
                                {element.name}
                            </option>))}
                    </AvField>
                </AvGroup>
            </div>
        );
    }

    renderInvoiceOptionCheckboxes() {
        return (
            <div className="invoice-detail-options-panel" role="group" aria-label="Invoice options">
                {this.renderInvoiceOptionCheckbox('includeTax', 'Inc VAT')}
                {this.renderInvoiceOptionCheckbox('useInvoiceBarcode', 'Use Invoice Barcode')}
                {this.renderInvoiceOptionCheckbox('readBoxQuantityFromProduct', 'Ignore Box Quantity')}
            </div>
        );
    }

    renderInvoiceOptionCheckbox(name, label) {
        const optionsDisabled = !this.isInvoiceHeaderEditable();
        const supplierLocked = ['useInvoiceBarcode', 'readBoxQuantityFromProduct'].includes(name);
        const disabled = optionsDisabled || (supplierLocked && this.checkSupplierApproved());
        const checked = !!this.state.license[name];
        const inputId = `invoice-opt-${name}`;

        return (
            <div
                key={name}
                className={`invoice-detail-option${disabled ? ' is-disabled' : ''}`}
                onClick={(e) => {
                    if (disabled) {
                        return;
                    }
                    // toggle when clicking the row (not the box itself — checkbox handles its own click)
                    if (e.target.closest('.p-checkbox')) {
                        return;
                    }
                    this.setChecked(name, !checked);
                }}
            >
                <Checkbox
                    inputId={inputId}
                    onChange={(e) => this.setChecked(name, e.checked)}
                    name={name}
                    disabled={disabled}
                    checked={checked}
                />
                <span className="invoice-detail-option__text" id={`${inputId}-label`}>
                    {label}
                </span>
            </div>
        );
    }

    renderInvoiceItemsTotalField() {
        const mismatch = this.isDifferent();
        return (
            <div className="invoice-detail-field invoice-detail-field--metric">
                <span className="invoice-detail-metric-label">Items Total</span>
                <div
                    className={`invoice-detail-metric-value${mismatch ? ' invoice-detail-metric-value--alert' : ''}`}
                    title={mismatch ? 'Items Total differs from Invoice Total' : ''}
                >
                    {this.formatInvoiceMoney(this.calculateItemsTotalPrice())}
                </div>
            </div>
        );
    }

    renderInvoiceTotalProfitField() {
        return (
            <div className="invoice-detail-field invoice-detail-field--metric">
                <span className="invoice-detail-metric-label">Total Profit</span>
                <div className="invoice-detail-metric-value">
                    {this.formatInvoiceMoney(this.calculateTotalProfit())}
                </div>
            </div>
        );
    }

    renderInvoiceSubtotalField() {
        return (
            <div className="invoice-detail-field invoice-detail-field--amount invoice-detail-field--subtotal">
                <span className="invoice-detail-metric-label">
                    <Translate contentKey="merchantBranch.totalNet">Invoice Subtotal</Translate>
                    <span style={{color: 'red'}}> (*)</span>
                </span>
                <NumberFormat
                    value={this.state.license.totalNet}
                    className="number-format-input"
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={'£'}
                    onValueChange={(values) => {
                        this.setState(prev => ({
                            license: {...prev.license, totalNet: values.value}
                        }));
                    }}
                    disabled={!this.isInvoiceHeaderEditable()}
                />
            </div>
        );
    }

    renderInvoiceTotalField() {
        return (
            <div className="invoice-detail-field invoice-detail-field--amount invoice-detail-field--total">
                <span className="invoice-detail-metric-label">
                    <Translate contentKey="merchantBranch.totalAmount">Invoice Total</Translate>
                    <span style={{color: 'red'}}> (*)</span>
                </span>
                <NumberFormat
                    value={this.state.license.totalAmount}
                    className="number-format-input"
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={'£'}
                    onValueChange={(values) => {
                        this.setState(prev => ({
                            license: {...prev.license, totalAmount: values.value}
                        }));
                    }}
                    disabled={!this.isInvoiceHeaderEditable()}
                />
            </div>
        );
    }

    renderSupplierOptionsRow() {
        return (
            <>
                {this.renderTillPriceCalculatorField()}
                {this.renderTillUserField()}
                {this.renderInvoiceOptionCheckboxes()}
            </>
        );
    }

    renderSupplier() {
        return (
            <>
                {this.renderSupplierNameField()}
                {this.renderSupplierOptionsRow()}
            </>
        );
    }


    closeDisplayDialogFilter = () => {
        this.setState({displayDialogFilter: false});
    }

    onDataSelectFilter = (data) => {
        let license = this.state.license;
        license["supplierId"] = data.id;
        license["supplierName"] = data.name;
        license["supplierBssId"] = data.bssId;
        license["supplierAccountCode"] = data.supplierAccountCode;
        license["supplierVatNumber"] = data.vatNumber;
        license["postcode"] = data.postcode;
        license["supplierPhoneNumber"] = data.phone;


        this.setState({
            license: license,
            displayDialogFilter: false
        }, () => {

        });


    }

    generatePurchaseOrderItemFields(departmentList = []) {
        const rowNoColumn = {
            field: '_rowNo',
            header: '#',
            visible: true,
            editable: false,
            style: { width: '20px', textAlign: 'center' },
            headerStyle: { width: '20px', textAlign: 'center' }
        };

        let fields = cloneDeep(
            GeneralUtils.isMobile()
                ? PurchaseOrderItemMobileColumn.fields
                : PurchaseOrderItemColumn.fields
        );
        fields.unshift(rowNoColumn);

        let enableDesktopScroll = false;

        if (!GeneralUtils.isMobile()) {
            const purchaseOrderItemListFields = this.state.purchaseOrderItemListFields;

            if (purchaseOrderItemListFields && purchaseOrderItemListFields.length > 0) {
                enableDesktopScroll = true;
                 fields = cloneDeep(
                        PurchaseOrderItemResizableColumn.fields
                );
                fields.unshift(rowNoColumn);
                fields = fields.map(f => ({
                    ...f,
                    visible: f.field === '_rowNo' || f.field?.startsWith('button.') || f.field?.startsWith('badge.')
                        ? true
                        : purchaseOrderItemListFields.includes(f.field)
                }));
            }
        }

        const width = window.innerWidth;

        fields = fields.map(f => {
            if (f.maxWidthVisible && width < f.maxWidthVisible) return { ...f, visible: false };
            if (f.minWidthVisible && width > f.minWidthVisible) return { ...f, visible: false };
            return f;
        });

        const departmentField = fields.find(f => f.field === 'departmentId');
        if (departmentField) {
            departmentField.dataElement = departmentList.reduce((acc, dept) => {
                acc[dept.id] = dept.name;
                return acc;
            }, {});
        }

        const tillCalcMethodItemField = fields.find(
            f => f.field === 'tillPriceCalculationMethod'
        );
        if (tillCalcMethodItemField) {
            tillCalcMethodItemField.dataElement = TILL_PRICE_ITEM_CALCULATION_METHOD.reduce(
                (acc, el) => {
                    acc[el.value] = el.name;
                    return acc;
                },
                {}
            );
        }

        // Ensure magnifying glass column exists at end (popup open), next to row OK/Cancel.
        const searchField = {
            field: 'button.search',
            visible: true,
            button: {icon: 'pi pi-search', function: 'select', disabled: false},
            style: {width: '2.75rem', minWidth: '2.75rem', textAlign: 'center'},
            header: '',
            headerStyle: {width: '2.75rem', textAlign: 'center'}
        };
        fields = fields.filter(f => f.field !== 'button.search');
        fields.push(searchField);

        if (this.state.desktopScroll !== enableDesktopScroll) {
            this.setState({ desktopScroll: enableDesktopScroll });
        }

        return fields;
    }


    calculateFields = (product, field) => {
        try {
            const newProduct = {...product};
            const HUNDRED = new Decimal(100);

            if (field === "barcode") {
                newProduct['ItemBssId'] = null;
                newProduct['barcodeIsSearched'] = false;
            }

            newProduct['recommendedSalePrice'] = null;
            newProduct['actualMargin'] = null;
            newProduct['unitCost'] = null;
            newProduct['costPrice'] = null;
            newProduct['taxPrice'] = null;

            if (GeneralUtils.isNullOrEmpty(newProduct['barcode'])) {
                newProduct['itemBssId'] = null;
            }

            const boxQty = new Decimal(newProduct.boxSize || 1);
            const deliveryQuantity = new Decimal(newProduct.deliveryQuantity || 1);
            const totalPrice = new Decimal(newProduct.totalPrice || 0.0);
            const profitMargin = new Decimal(newProduct.profitMargin || 0.0);
            const vatRate = new Decimal(newProduct.taxRate || 0.0);

            // boxPrice = totalPrice / deliveryQuantity
            const boxPrice = deliveryQuantity.isZero()
                ? new Decimal(0)
                : totalPrice.div(deliveryQuantity).toDecimalPlaces(6);

            newProduct['boxPrice'] = parseFloat(
                boxPrice.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString()
            );

            // Cur. Unit Cost - hesaplanan alan (currentBoxPrice / currentBoxSize veya boxSize)
            const divisorForUnitCost = newProduct.currentBoxSize ?? newProduct.boxSize;
            if (
                newProduct.currentBoxPrice != null &&
                divisorForUnitCost != null &&
                Number(divisorForUnitCost) !== 0
            ) {

                newProduct.currentUnitCost = parseFloat(
                    new Decimal(newProduct.currentBoxPrice)
                        .div(new Decimal(divisorForUnitCost))
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
                        .toString()
                );
            } else {
                newProduct.currentUnitCost = null;
            }

            let unitCost;
            if (boxPrice == null || boxQty == null || boxQty.isZero()) {
                unitCost = new Decimal(0);
            } else {
                unitCost = boxPrice
                    .div(boxQty)
                    .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
            }

            newProduct['unitCost'] = parseFloat(unitCost.toString());

            let costPrice = new Decimal(0);
            let taxPrice = new Decimal(0);

            if (this.state.license?.includeTax) {
                costPrice = unitCost.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                if (!costPrice.isZero() && !vatRate.isZero()) {
                    taxPrice = costPrice.times(vatRate)
                        .div(HUNDRED.plus(vatRate))
                        .times(deliveryQuantity)
                        .times(boxQty)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                } else {
                    taxPrice = new Decimal(0);
                }
            } else {
                const vatMultiplierPrecise = vatRate.plus(HUNDRED).div(HUNDRED).toDecimalPlaces(6);
                if (unitCost.isZero()) {
                    costPrice = new Decimal(0);
                    taxPrice = new Decimal(0);
                } else {
                    costPrice = unitCost.times(vatMultiplierPrecise).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                    taxPrice = costPrice.minus(unitCost)
                        .times(deliveryQuantity)
                        .times(boxQty)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                }
            }

            newProduct['costPrice'] = parseFloat(costPrice.toString());
            newProduct['taxPrice'] = parseFloat(taxPrice.toString());

            const marginMultiplier = profitMargin.plus(HUNDRED).div(HUNDRED);
            let recommendedSalePrice = costPrice.times(marginMultiplier).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

            const method =
                newProduct.tillPriceCalculationMethod && newProduct.tillPriceCalculationMethod.trim() !== ""
                    ? newProduct.tillPriceCalculationMethod
                    : this.state.license?.tillPriceCalculationMethod;

            if (method) {
                switch (method) {
                    case "NEAREST_9":
                        recommendedSalePrice = CalculationUtils.roundNearest9(recommendedSalePrice);
                        break;
                    case "NEAREST_49_99":
                        recommendedSalePrice = CalculationUtils.roundNearest49_99(recommendedSalePrice);
                        break;
                    case "NEAREST_00":
                        recommendedSalePrice = CalculationUtils.roundNearest00(recommendedSalePrice);
                        break;
                    case "NEAREST_50":
                        recommendedSalePrice = CalculationUtils.roundNearest50(recommendedSalePrice);
                        break;
                    case "CURRENT_PRICE":
                        if (!GeneralUtils.isNullOrEmpty(newProduct.oldPrice)) {
                            recommendedSalePrice = new Decimal(newProduct.oldPrice);
                        }
                        break;
                }
            }

            newProduct['recommendedSalePrice'] = parseFloat(recommendedSalePrice.toString());

            if (method !== "PRICE_MARK" && method !== "MANUAL_ENTRY") {
                if (method === "CURRENT_PRICE") {
                    if (!GeneralUtils.isNullOrEmpty(newProduct.oldPrice)) {
                        newProduct['salePrice'] = parseFloat(new Decimal(newProduct.oldPrice).toString());
                    } else {
                        newProduct['salePrice'] = parseFloat(recommendedSalePrice.toString());
                    }
                } else if (newProduct.oldPrice != null && recommendedSalePrice < newProduct.oldPrice) {
                    newProduct['salePrice'] = newProduct.oldPrice;
                } else if (
                    newProduct.oldPrice != null &&
                    newProduct.oldPrice !== 0 &&
                    newProduct.currentUnitCost != null &&
                    newProduct.currentUnitCost !== 0 &&
                    newProduct.unitCost != null &&
                    newProduct.unitCost !== 0 &&
                    new Decimal(newProduct.currentUnitCost)
                        .minus(new Decimal(newProduct.unitCost))
                        .abs()
                        .lte(
                            new Decimal(newProduct.currentUnitCost)
                                .abs()
                                .times(new Decimal(this.state.defaultCostPricePercentage ?? 0))
                                .div(HUNDRED)
                        )
                ) {
                    // currentActualMargin: eski fiyat / Cur. Unit Cost
                    const currentActualMargin = new Decimal(newProduct.oldPrice)
                        .div(new Decimal(newProduct.currentUnitCost))
                        .times(HUNDRED)
                        .minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

                    // newActualMargin: yeni fiyat / Unit Cost
                    const newActualMargin = recommendedSalePrice
                        .div(new Decimal(newProduct.unitCost))
                        .times(HUNDRED)
                        .minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

                    // tolerans: mevcut marjın ±%10'u (örn. 40 → 36–44, 50 → 45–55)
                    const tolerance = currentActualMargin.abs().times(0.10);
                    const diff = newActualMargin.minus(currentActualMargin).abs();

                    if (diff.lte(tolerance)) {
                        newProduct['salePrice'] = newProduct.oldPrice;
                    } else {
                        newProduct['salePrice'] = parseFloat(recommendedSalePrice.toString());
                    }
                } else {
                    newProduct['salePrice'] = parseFloat(recommendedSalePrice.toString());
                }
            }

            const itemPrice = new Decimal(newProduct.salePrice || 0.0);
            if (!costPrice.isZero()) {
                newProduct['actualMargin'] = parseFloat(
                    itemPrice.div(costPrice).times(HUNDRED).minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString()
                );
                if (newProduct.salePrice === newProduct.recommendedSalePrice) {
                    newProduct['actualMargin'] = newProduct.profitMargin;
                }
            } else {
                newProduct['actualMargin'] = 0;
            }

            const profit = (new Decimal(newProduct.salePrice || 0))
                .minus(unitCost)
                .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
            newProduct['profit'] = parseFloat(profit.toString());

            const totalProfit = profit
                .times(new Decimal(newProduct.deliveryQuantity || 0))
                .times(new Decimal(newProduct.boxSize || 0))
                .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

            newProduct['totalProfit'] = parseFloat(totalProfit.toString());

            newProduct['newStock'] =
                (newProduct.deliveryQuantity || 0) * (newProduct.boxSize || 0);

            return newProduct;

        } catch (e) {
            console.error("calculateFields error:", e);
            return {...product};
        }

    }

    isUploadInvoice = () => this.state.license?.invoiceType === 'UPLOAD';

    /** Invoice created via “From Delivery Note” — DN is fixed/linked at create time. */
    isFromDeliveryNoteInvoice = () => this.state.license?.invoiceType === 'FROM_DELIVERY_NOTE';

    /** Right-side Delivery Note panel (UPLOAD choosable; FROM_DELIVERY_NOTE read-only). */
    showsDeliveryNoteSidePanel = () => this.isUploadInvoice() || this.isFromDeliveryNoteInvoice();

    /** Manual Entry + From Delivery Note share form/validation UX (not UPLOAD/CSV paths). */
    isManualStyleInvoice = () => {
        const t = this.state.license?.invoiceType;
        return t === 'MANUAL_ENTRY' || t === 'FROM_DELIVERY_NOTE';
    };

    isDeliveryNoteNoneSelected = () => {
        const license = this.state.license || {};
        return isDeliveryNoteNoneFlag(license.deliveryNoteNone)
            || isNoneDeliveryNoteId(license.assignedDeliveryNoteId);
    };

    hasDeliveryNoteChoice = () => {
        if (!this.isUploadInvoice()) {
            return true;
        }
        const license = this.state.license || {};
        return this.isDeliveryNoteNoneSelected()
            || (!GeneralUtils.isNullOrEmpty(license.assignedDeliveryNoteId)
                && !isNoneDeliveryNoteId(license.assignedDeliveryNoteId));
    };

    getDeliveryNoteCardTitle = () => {
        if (this.isDeliveryNoteNoneSelected()) {
            return 'NONE';
        }
        const license = this.state.license || {};
        return license.assignedDeliveryNoteNo
            || this.state.assignedDeliveryNote?.requisitionNo
            || 'Select Delivery Note';
    };

    resolveInitialDetailTabIndex = (license) => {
        let openPayments = false;
        try {
            openPayments = sessionStorage.getItem('purchaseOrder.openDetailPaymentsTab') === '1';
            sessionStorage.removeItem('purchaseOrder.openDetailPaymentsTab');
        } catch (e) {
            openPayments = false;
        }
        if (!openPayments || license?.purchaseOrderStatus !== 'CLOSED') {
            return 0;
        }
        const showCompare = license?.invoiceType === 'UPLOAD'
            && !GeneralUtils.isNullOrEmpty(license?.assignedDeliveryNoteId)
            && !isNoneDeliveryNoteId(license?.assignedDeliveryNoteId);
        return showCompare ? 3 : 1;
    };

    isInvoiceEditable = () =>
        this.state.licenseSaveButtonRender
        && this.state.license.purchaseOrderStatus !== 'CLOSED'
        && this.state.license.purchaseOrderStatus !== 'PARTIAL_CLOSED';

    loadAssignedDeliveryNoteForCompare = (deliveryNoteId) => {
        if (!this.isUploadInvoice()
            || GeneralUtils.isNullOrEmpty(deliveryNoteId)
            || isNoneDeliveryNoteId(deliveryNoteId)) {
            this.setState({
                assignedDeliveryNote: null,
                invoiceDnComparisonRows: [],
                invoiceDnDispositions: {},
                invoiceDnResolutionSnapshots: {},
                invoiceDnResolutionSelections: {},
                invoiceDnResolutionSelectionLabels: {}
            });
            return Promise.resolve(null);
        }
        return this.purchaseRequisitionService.findById(deliveryNoteId).then(response => {
            if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    assignedDeliveryNote: null,
                    invoiceDnComparisonRows: [],
                    invoiceDnDispositions: {},
                    invoiceDnResolutionSnapshots: {},
                    invoiceDnResolutionSelections: {},
                    invoiceDnResolutionSelectionLabels: {}
                });
                return null;
            }
            // New DN link: clear prior Only-on-DN actions (barcodes may differ).
            const previousDnId = this.state.assignedDeliveryNote?.id;
            const sameDn = previousDnId != null && Number(previousDnId) === Number(deliveryNoteId);
            const dnChanged = previousDnId != null && Number(previousDnId) !== Number(deliveryNoteId);
            if (dnChanged) {
                clearDnResolutionState(this.state.license?.id);
            }
            const dispositions = sameDn ? (this.state.invoiceDnDispositions || {}) : {};
            const rows = buildInvoiceDeliveryNoteComparisonRows(
                this.state.license?.itemList,
                response.itemList,
                dispositions
            );
            this.setState({
                assignedDeliveryNote: response,
                invoiceDnComparisonRows: rows,
                invoiceDnDispositions: dispositions,
                ...(dnChanged
                    ? {
                        invoiceDnResolutionSnapshots: {},
                        invoiceDnResolutionSelections: {},
                        invoiceDnResolutionSelectionLabels: {}
                    }
                    : this.applyLoadedDnResolutionState(
                        this.state.license?.id,
                        response.itemList,
                        this.state.license?.itemList
                    ))
            });
            return response;
        }).catch(() => {
            this.setState({
                assignedDeliveryNote: null,
                invoiceDnComparisonRows: [],
                invoiceDnDispositions: {},
                invoiceDnResolutionSnapshots: {},
                invoiceDnResolutionSelections: {},
                invoiceDnResolutionSelectionLabels: {}
            });
            return null;
        });
    };

    refreshInvoiceDnComparison = () => {
        if (!this.isUploadInvoice() || !this.state.assignedDeliveryNote) {
            if (!this.isUploadInvoice()
                || GeneralUtils.isNullOrEmpty(this.state.license?.assignedDeliveryNoteId)
                || isNoneDeliveryNoteId(this.state.license?.assignedDeliveryNoteId)) {
                this.setState({invoiceDnComparisonRows: []});
            }
            return;
        }
        const rows = buildInvoiceDeliveryNoteComparisonRows(
            this.state.license?.itemList,
            this.state.assignedDeliveryNote.itemList,
            this.state.invoiceDnDispositions
        );
        this.setState({invoiceDnComparisonRows: rows});
    };

    onInvoiceDnDispositionChange = (rowData, disposition) => {
        const barcode = rowData?.barcode;
        if (GeneralUtils.isNullOrEmpty(barcode)) {
            return;
        }
        const nextDisposition = normalizeDnOnlyDisposition(disposition);
        this.setState(prev => {
            const invoiceDnDispositions = {
                ...prev.invoiceDnDispositions,
                [barcode]: nextDisposition
            };
            // Default Accepted: drop key to keep payload lean
            if (nextDisposition === DN_ONLY_DISPOSITION.ACCEPTED) {
                delete invoiceDnDispositions[barcode];
            }
            const invoiceDnComparisonRows = buildInvoiceDeliveryNoteComparisonRows(
                prev.license?.itemList,
                prev.assignedDeliveryNote?.itemList,
                invoiceDnDispositions
            );
            return {invoiceDnDispositions, invoiceDnComparisonRows};
        });
    };

    getInvoiceCompareTabHeader = () => {
        const issueCount = countInvoiceDnComparisonIssues(this.state.invoiceDnComparisonRows);
        if (issueCount > 0) {
            return `Compare with Delivery Note (${issueCount})`;
        }
        return 'Compare with Delivery Note';
    };

    renderInvoiceItemsSection = (filteredItems, isMobile) => {
        return (
            <FormSection
                className="invoice-items-section"
                title={
                    <div className="invoice-items-section__header">
                        {this.renderFilter()}
                    </div>
                }
            >
                <Dialog visible={this.state.displayDialog}
                        header={""}
                        onHide={() => this.setState({displayDialog: false})}
                        style={GeneralUtils.getDialogStyleForPurchaseOrder()}>

                    <PurchaseOrderItemSave ref={(elem) => this.refModelSave = elem}
                                           refreshDataTable={this.refreshDataTable}
                                           calculateFields={this.calculateFields}
                                           deleteItemData={this.deleteItemData}
                                           openNextItem={this.openNextItem}
                                           updatePurchaseOrderItem={this.updatePurchaseOrderItem}
                                           updatePurchaseOrderItemFieldsOnly={this.updatePurchaseOrderItemFieldsOnly}
                                           updatePurchaseOrderItemAndNext={this.updatePurchaseOrderItemAndNext}
                                           updatePurchaseOrderItemAndNextUnmatched={this.updatePurchaseOrderItemAndNextUnmatched}
                                           closePurchaseOrderItemAndNext={this.closePurchaseOrderItemAndNext}
                                           closePurchaseOrderItemAndNextUnmatched={this.closePurchaseOrderItemAndNextUnmatched}
                                           closeDisplayDialog={this.closeDisplayDialog}
                                           refreshOrderAndClose={this.refreshOrderAndClose}
                                           isEditMode={this.state.licenseSaveButtonRender && this.checkSupplierApproved()}/>
                </Dialog>

                {this.renderSelectItems()}

                <DataTableWithButton
                    data={filteredItems}
                    purchaseOrderHighlight
                    key={this.state.licenseSaveButtonRender ? "edit" : "view"}
                    ref={(elem) => this.refDataTable = elem}
                    selectionMode="single"
                    paginator
                    rows={50}
                    className={`custom-datatable ${
                        !isMobile && this.state.desktopScroll ? 'desktop-scroll' : ''
                    } ${
                        !isMobile && this.state.desktopScroll ? 'purchase-order-items-table' : ''
                    }`}
                    scrollable={!isMobile && this.state.desktopScroll}
                    scrollDirection={!isMobile && this.state.desktopScroll ? "horizontal" : null}
                    editMode={
                        !isMobile &&
                        this.state.licenseSaveButtonRender &&
                        this.checkSupplierApproved()
                            ? "row"
                            : null
                    }
                    dataKey={
                        !isMobile &&
                        this.state.licenseSaveButtonRender &&
                        this.checkSupplierApproved()
                            ? "id"
                            : null
                    }
                    first={this.state.first}
                    onPage={(e) => {
                        this.setState({first: e.first, rows: e.rows}, () =>
                            this.setAllRowsEditable()
                        );
                    }}
                    search={this.searchByBarcode}
                    buttonDisabled={!this.state.licenseSaveButtonRender}
                    purchaseOrderStatus={this.state.license.purchaseOrderStatus}
                    select={this.onDataSelect}
                    setStateData={this.setStateData}
                    calculateFields={this.calculateFields}
                    checkSupplierApproved={this.checkSupplierApproved}
                    delete={this.showChangeStatusConfirmDialog}
                    fields={this.generatePurchaseOrderItemFields(this.state.departmentList)}
                    rowClassName={(rowData) => (rowData.shouldWarnUser === true ? {highlightTableRowLightRed: true} : {})}
                />
            </FormSection>
        );
    };

    clonePaymentDraftList = (paymentList) => {
        return (paymentList || []).map(payment => {
            let paymentDate = payment.paymentDate;
            if (paymentDate != null && paymentDate !== '') {
                const parsed = dayjs(paymentDate);
                paymentDate = parsed.isValid() ? parsed.valueOf() : Date.now();
            } else {
                paymentDate = Date.now();
            }
            return {
                id: payment.id || null,
                paymentDate,
                amount: payment.amount,
                paymentMethod: payment.paymentMethod || 'BANK',
                referenceNo: payment.referenceNo || '',
                note: payment.note || ''
            };
        });
    };

    renderPaymentSection = () => {
        if (this.state.license?.purchaseOrderStatus !== 'CLOSED' || GeneralUtils.isNullOrEmpty(this.state.license?.id)) {
            return (
                <div className="invoice-payments invoice-payments--locked text-muted">
                    Payments are available after the invoice is confirmed (CLOSED).
                </div>
            );
        }
        const paymentsLocked = !!this.state.paymentsLocked;
        const invoiceTotal = Number(this.state.license.totalAmount || 0);
        const draftPaid = (this.state.paymentDraftList || []).reduce((sum, row) => sum + Number(row.amount || 0), 0);
        const remaining = invoiceTotal - draftPaid;
        const paymentStatus = this.state.license.paymentStatus || 'UNPAID';
        const statusLabel = (PURCHASE_ORDER_PAYMENT_STATUS.find(s => s.value === paymentStatus) || {}).name || paymentStatus;
        let paymentDueDate = this.state.license.paymentDueDate;
        if (paymentDueDate != null && paymentDueDate !== '' && typeof paymentDueDate === 'string') {
            const parsed = dayjs(paymentDueDate);
            paymentDueDate = parsed.isValid() ? parsed.valueOf() : paymentDueDate;
        }

        const dueUrgency = (() => {
            if (remaining <= 0.0001 || paymentDueDate == null || paymentDueDate === '') {
                return null;
            }
            const due = dayjs(paymentDueDate);
            if (!due.isValid()) {
                return null;
            }
            const dueKey = due.format('YYYY-MM-DD');
            const todayKey = dayjs().format('YYYY-MM-DD');
            if (dueKey < todayKey) {
                return 'overdue';
            }
            if (dueKey === todayKey) {
                return 'due-today';
            }
            return null;
        })();

        const statusClass = paymentStatus === 'PAID'
            ? 'invoice-payments__status--paid'
            : paymentStatus === 'PARTIAL'
                ? 'invoice-payments__status--partial'
                : 'invoice-payments__status--unpaid';

        const paymentRows = this.state.paymentDraftList || [];

        return (
            <div className={`invoice-payments${dueUrgency ? ` invoice-payments--${dueUrgency}` : ''}`}>
                <div className="invoice-payments__summary">
                    <div className="invoice-payments__metric">
                        <span className="invoice-payments__metric-label">Invoice Total</span>
                        <span className="invoice-payments__metric-value">£{invoiceTotal.toFixed(2)}</span>
                    </div>
                    <div className="invoice-payments__metric">
                        <span className="invoice-payments__metric-label">Paid</span>
                        <span className="invoice-payments__metric-value">£{draftPaid.toFixed(2)}</span>
                    </div>
                    <div className={`invoice-payments__metric${remaining > 0.0001 ? ' invoice-payments__metric--remaining' : ''}`}>
                        <span className="invoice-payments__metric-label">Remaining</span>
                        <span className="invoice-payments__metric-value">£{remaining.toFixed(2)}</span>
                    </div>
                    <div className="invoice-payments__metric invoice-payments__metric--status">
                        <span className="invoice-payments__metric-label">Payment Status</span>
                        <span className={`invoice-payments__status ${statusClass}`}>{statusLabel}</span>
                    </div>
                </div>

                <div className={`invoice-payments__due${dueUrgency ? ` invoice-payments__due--${dueUrgency}` : ''}`}>
                    <div className="invoice-payments__due-field">
                        <Label>Payment Due Date</Label>
                        {dueUrgency === 'overdue' && (
                            <span className="invoice-payments__due-badge">Overdue</span>
                        )}
                        {dueUrgency === 'due-today' && (
                            <span className="invoice-payments__due-badge invoice-payments__due-badge--today">Due today</span>
                        )}
                        <DateInput
                            name="paymentDueDate"
                            format="DD/MM/YYYY"
                            value={paymentDueDate || ''}
                            disabled={paymentsLocked}
                            onChange={(e) => this.setState({
                                license: {...this.state.license, paymentDueDate: e.target.value}
                            })}
                        />
                    </div>
                </div>

                <div className="invoice-payments__lines">
                    <div className="invoice-payments__lines-header">
                        <span className="invoice-payments__section-title">Payment lines</span>
                        <div className="invoice-payments__actions">
                            {paymentsLocked ? (
                                <Button
                                    color="outline-primary"
                                    type="button"
                                    onClick={() => this.setState({paymentsLocked: false})}
                                >
                                    Edit Payments
                                </Button>
                            ) : (
                                <>
                                    <Button color="outline-primary" type="button" onClick={this.addPaymentDraftRow}>
                                        Add Payment
                                    </Button>
                                    <Button
                                        color="primary"
                                        type="button"
                                        disabled={this.state.paymentSaving}
                                        onClick={this.saveInvoicePayments}
                                    >
                                        Save Payments
                                    </Button>
                                </>
                            )}
                        </div>
                    </div>

                    {paymentRows.length === 0 && (
                        <div className="invoice-payments__empty text-muted">
                            No payments recorded yet. Click Add Payment to record one.
                        </div>
                    )}

                    {paymentRows.map((payment, index) => {
                        const maxAmount = this.getMaxAmountForPaymentRow(index);
                        return (
                            <div key={`payment-row-${index}`} className="invoice-payments__row">
                                <div className="invoice-payments__cell invoice-payments__cell--date">
                                    <Label>Date</Label>
                                    <DateInput
                                        name={`paymentDate_${index}`}
                                        format="DD/MM/YYYY"
                                        value={payment.paymentDate || ''}
                                        disabled={paymentsLocked}
                                        onChange={(e) => this.updatePaymentDraftField(index, 'paymentDate', e.target.value)}
                                    />
                                </div>
                                <div className="invoice-payments__cell invoice-payments__cell--amount">
                                    <Label>Amount</Label>
                                    <NumberFormat
                                        className="form-control"
                                        type="text"
                                        thousandSeparator={false}
                                        decimalScale={2}
                                        allowNegative={false}
                                        disabled={paymentsLocked}
                                        value={payment.amount == null ? '' : payment.amount}
                                        isAllowed={(values) => {
                                            if (values.floatValue == null) {
                                                return true;
                                            }
                                            return values.floatValue <= maxAmount + 0.0001;
                                        }}
                                        onValueChange={(values) => this.updatePaymentDraftField(index, 'amount', values.floatValue)}
                                    />
                                </div>
                                <div className="invoice-payments__cell invoice-payments__cell--method">
                                    <Label>Method</Label>
                                    <select
                                        className="form-control"
                                        value={payment.paymentMethod || 'BANK'}
                                        disabled={paymentsLocked}
                                        onChange={(e) => this.updatePaymentDraftField(index, 'paymentMethod', e.target.value)}
                                    >
                                        {PURCHASE_ORDER_PAYMENT_METHOD.map(element => (
                                            <option value={element.value} key={element.value}>{element.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="invoice-payments__cell invoice-payments__cell--ref">
                                    <Label>Reference</Label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment.referenceNo || ''}
                                        disabled={paymentsLocked}
                                        onChange={(e) => this.updatePaymentDraftField(index, 'referenceNo', e.target.value)}
                                    />
                                </div>
                                <div className="invoice-payments__cell invoice-payments__cell--note">
                                    <Label>Note</Label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment.note || ''}
                                        disabled={paymentsLocked}
                                        onChange={(e) => this.updatePaymentDraftField(index, 'note', e.target.value)}
                                    />
                                </div>
                                <div className="invoice-payments__cell invoice-payments__cell--remove">
                                    <Button
                                        color="outline-danger"
                                        type="button"
                                        disabled={paymentsLocked}
                                        onClick={() => this.removePaymentDraftRow(index)}
                                    >
                                        Remove
                                    </Button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    getInvoiceTotalAmount = () => {
        return Number(this.state.license?.totalAmount || 0);
    };

    getDraftPaidExcluding = (excludeIndex) => {
        return (this.state.paymentDraftList || []).reduce((sum, row, index) => {
            if (excludeIndex != null && index === excludeIndex) {
                return sum;
            }
            return sum + Number(row.amount || 0);
        }, 0);
    };

    getRemainingAmount = (excludeIndex = null) => {
        const remaining = this.getInvoiceTotalAmount() - this.getDraftPaidExcluding(excludeIndex);
        return Math.max(0, Number(remaining.toFixed(2)));
    };

    getMaxAmountForPaymentRow = (index) => {
        return this.getRemainingAmount(index);
    };

    updatePaymentDraftField = (index, field, value) => {
        const paymentDraftList = [...(this.state.paymentDraftList || [])];
        if (!paymentDraftList[index]) {
            return;
        }
        let nextValue = value;
        if (field === 'amount' && nextValue != null && nextValue !== '') {
            const maxAmount = this.getMaxAmountForPaymentRow(index);
            if (Number(nextValue) > maxAmount) {
                nextValue = maxAmount;
            }
        }
        paymentDraftList[index] = {...paymentDraftList[index], [field]: nextValue};
        this.setState({paymentDraftList});
    };

    addPaymentDraftRow = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        const remaining = this.getRemainingAmount();
        if (remaining <= 0) {
            toast.warn('Nothing remaining to pay');
            return;
        }
        const paymentDraftList = [...(this.state.paymentDraftList || [])];
        paymentDraftList.push({
            id: null,
            paymentDate: Date.now(),
            amount: remaining,
            paymentMethod: 'BANK',
            referenceNo: '',
            note: ''
        });
        this.setState({paymentDraftList});
    };

    removePaymentDraftRow = (index) => {
        const paymentDraftList = [...(this.state.paymentDraftList || [])];
        paymentDraftList.splice(index, 1);
        this.setState({paymentDraftList});
    };

    saveInvoicePayments = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        const purchaseOrderId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(purchaseOrderId)) {
            return;
        }
        const paymentList = (this.state.paymentDraftList || []).map(payment => ({
            paymentDate: this.toBackendDateTime(payment.paymentDate),
            amount: payment.amount,
            paymentMethod: payment.paymentMethod || 'OTHER',
            referenceNo: payment.referenceNo || null,
            note: payment.note || null
        }));
        for (const payment of paymentList) {
            if (payment.amount == null || payment.amount === '' || Number(payment.amount) <= 0) {
                toast.warn('Each payment must have an amount greater than zero');
                return;
            }
        }
        const totalPaid = paymentList.reduce((sum, payment) => sum + Number(payment.amount || 0), 0);
        const invoiceTotal = this.getInvoiceTotalAmount();
        if (totalPaid > invoiceTotal + 0.0001) {
            toast.warn('Total payments cannot exceed invoice total');
            return;
        }
        this.setState({paymentSaving: true});
        const paymentDueDate = this.toBackendDateTime(this.state.license?.paymentDueDate);
        this.purchaseOrderService.savePayments(purchaseOrderId, {
            paymentList,
            paymentDueDate: paymentDueDate || null
        }).then(response => {
            this.setState({paymentSaving: false});
            if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                return;
            }
            this.setState({
                license: Object.assign({}, response),
                licenseTemp: Object.assign({}, response),
                paymentDraftList: this.clonePaymentDraftList(response.paymentList),
                paymentsLocked: true
            });
        }).catch(() => this.setState({paymentSaving: false}));
    };

    renderInvoiceDeliveryNoteCompareSection() {
        if (!this.isUploadInvoice()) {
            return null;
        }
        if (GeneralUtils.isNullOrEmpty(this.state.license?.assignedDeliveryNoteId)
            || isNoneDeliveryNoteId(this.state.license?.assignedDeliveryNoteId)
            || this.isDeliveryNoteNoneSelected()) {
            return (
                <div className="text-muted" style={{padding: '16px 0'}}>
                    Select a closed Delivery Note above to compare invoice quantities with delivered quantities.
                </div>
            );
        }
        const rows = this.state.invoiceDnComparisonRows || [];
        const issueCount = countInvoiceDnComparisonIssues(rows);
        const onlyOnDnActions = countPendingOnlyOnDnActions(rows);
        const dnNo = this.state.license.assignedDeliveryNoteNo
            || this.state.assignedDeliveryNote?.requisitionNo
            || '';
        const editable = this.isInvoiceEditable();
        return (
            <div>
                <div className={`purchase-requisition-compare-dialog__summary${issueCount > 0 ? ' has-issues' : ''}`}>
                    {dnNo ? `Linked: ${dnNo}. ` : ''}
                    {issueCount > 0
                        ? `${issueCount} difference(s) between invoice and Delivery Note quantities.`
                        : 'Invoice and Delivery Note quantities match.'}
                    {onlyOnDnActions > 0
                        ? ` ${onlyOnDnActions} Only-on-DN action(s) will apply on Confirm (stock reverse / return). DN is not updated.`
                        : ''}
                </div>
                {editable && issueCount > 0 &&
                    <div className="text-muted" style={{fontSize: '0.8125rem', marginBottom: '0.5rem'}}>
                        <strong>Only on DN</strong>: Accepted (do nothing) · Scanning error (reverse stock, no return)
                        · Wrong item (create return, no stock reverse). Applied when you fully Confirm this invoice.
                        Delivery Note is never updated. Only on Invoice Create Return remains via Confirm dialog (existing).
                    </div>
                }
                {rows.length > 0 &&
                    <PurchaseRequisitionItemDataTable
                        key={`invoice-dn-compare-${dnNo}-${rows.length}-${editable ? 'e' : 'v'}`}
                        data={rows}
                        selectionMode={null}
                        paginator={true}
                        rows={20}
                        dataKey="barcode"
                        fields={PurchaseOrderInvoiceDnCompareColumn.fields}
                        highlightCheaperCost={false}
                        invoiceDnDispositionEditable={editable}
                        onInvoiceDnDispositionChange={this.onInvoiceDnDispositionChange}
                        compareStatusLabels={{
                            MATCHED: 'Matched',
                            SHORT: 'Invoice > Net DN',
                            OVER: 'Net DN > Invoice',
                            MISSING: 'Only on invoice',
                            UNEXPECTED: 'Only on DN'
                        }}
                    />
                }
            </div>
        );
    }

    getInvoiceDnResolutionRows = () => {
        const snapshotKeys = Object.keys(this.state.invoiceDnResolutionSnapshots || {});
        const selectionKeys = Object.keys(this.state.invoiceDnResolutionSelections || {})
            .filter(key => this.state.invoiceDnResolutionSelections[key]);
        return getInvoiceDnResolutionItems(
            this.state.license?.itemList,
            this.getDuplicateItems,
            [...new Set([...snapshotKeys, ...selectionKeys])]
        );
    };

    persistDnResolutionStateToStorage = (overrides = null) => {
        const purchaseOrderId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(purchaseOrderId)) {
            return;
        }
        saveDnResolutionState(purchaseOrderId, {
            snapshots: overrides?.snapshots ?? this.state.invoiceDnResolutionSnapshots ?? {},
            selections: overrides?.selections ?? this.state.invoiceDnResolutionSelections ?? {},
            labels: overrides?.labels ?? this.state.invoiceDnResolutionSelectionLabels ?? {}
        });
    };

    applyLoadedDnResolutionState = (purchaseOrderId, dnItems, invoiceItems) => {
        const stored = loadDnResolutionState(purchaseOrderId);
        const hydrated = hydrateDnResolutionSelectionsFromBarcodes(
            invoiceItems,
            dnItems,
            stored
        );
        return {
            invoiceDnResolutionSnapshots: hydrated.snapshots,
            invoiceDnResolutionSelections: hydrated.selections,
            invoiceDnResolutionSelectionLabels: hydrated.labels
        };
    };

    getInvoiceDnResolutionTabHeader = () => {
        const count = this.getInvoiceDnResolutionRows().length;
        if (count > 0) {
            return `Resolution from Delivery Note (${count})`;
        }
        return 'Resolution from Delivery Note';
    };

    persistResolvedInvoiceItem = (data) => {
        const licenseId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(data?.id) || GeneralUtils.isNullOrEmpty(licenseId)) {
            this.updatePurchaseOrderItemFieldsOnly(data);
            return Promise.resolve(data);
        }
        return this.purchaseOrderService.updateItems(data)
            .then((itemResponse) => {
                if (GeneralUtils.isNullOrEmpty(itemResponse) || !GeneralUtils.isNullOrEmpty(itemResponse.type)) {
                    return null;
                }
                return this.purchaseOrderService.findById(licenseId);
            })
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    return null;
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense)
                }, () => this.refreshInvoiceDnComparison());
                return freshLicense;
            });
    };

    onInvoiceDnResolutionSelect = async (invoiceItem, dnKey) => {
        if (!this.isInvoiceEditable() || !invoiceItem) {
            return;
        }
        const invoiceKey = getInvoiceItemKey(invoiceItem);
        if (!invoiceKey) {
            return;
        }
        if (!dnKey) {
            this.setState(prev => ({
                invoiceDnResolutionSelections: {
                    ...prev.invoiceDnResolutionSelections,
                    [invoiceKey]: ''
                }
            }));
            return;
        }
        const ranked = rankDeliveryNoteOptionsForInvoiceItem(
            invoiceItem,
            filterAvailableDnItems(
                this.state.assignedDeliveryNote?.itemList,
                this.state.invoiceDnResolutionSelections,
                invoiceKey,
                dnKey
            )
        );
        const dnItem = ranked.find(opt => String(opt._dnKey || getDnItemKey(opt)) === String(dnKey));
        if (!dnItem) {
            toast.warn('Selected Delivery Note item was not found');
            return;
        }
        const dnBarcode = String(dnItem.barcode || '').trim();
        if (!dnBarcode) {
            toast.warn('Selected Delivery Note item has no barcode');
            return;
        }

        // Snapshot original BEFORE barcode/product overwrite; keep selection visible after refresh.
        const snapshots = {...(this.state.invoiceDnResolutionSnapshots || {})};
        if (!snapshots[invoiceKey]) {
            snapshots[invoiceKey] = snapshotInvoiceItemForDnResolution(invoiceItem);
        }
        const selections = {
            ...(this.state.invoiceDnResolutionSelections || {}),
            [invoiceKey]: String(dnKey)
        };
        const selectionLabels = {
            ...(this.state.invoiceDnResolutionSelectionLabels || {}),
            [invoiceKey]: formatDnOptionLabel(dnItem)
        };

        await new Promise(resolve => {
            this.setState({
                loading: true,
                invoiceDnResolutionSnapshots: snapshots,
                invoiceDnResolutionSelections: selections,
                invoiceDnResolutionSelectionLabels: selectionLabels
            }, () => {
                this.persistDnResolutionStateToStorage();
                resolve();
            });
        });

        try {
            let data = {...invoiceItem, barcode: dnBarcode};
            data = await this.searchByBarcode(data);
            data = this.calculateFields(data);
            // Keep selection/snapshot keys stable even if local fields change before server refresh.
            await this.persistResolvedInvoiceItem(data);
            this.setState(prev => ({
                invoiceDnResolutionSelections: {
                    ...prev.invoiceDnResolutionSelections,
                    [invoiceKey]: String(dnKey)
                },
                invoiceDnResolutionSelectionLabels: {
                    ...prev.invoiceDnResolutionSelectionLabels,
                    [invoiceKey]: selectionLabels[invoiceKey]
                },
                invoiceDnResolutionSnapshots: {
                    ...prev.invoiceDnResolutionSnapshots,
                    [invoiceKey]: prev.invoiceDnResolutionSnapshots?.[invoiceKey] || snapshots[invoiceKey]
                }
            }), () => this.persistDnResolutionStateToStorage());
        } catch (error) {
            console.error('DN resolution assign failed', error);
            toast.error('Could not resolve item from Delivery Note');
        } finally {
            this.setState({loading: false});
        }
    };

    revertInvoiceDnResolution = async (invoiceItem) => {
        if (!this.isInvoiceEditable() || !invoiceItem) {
            return;
        }
        const invoiceKey = getInvoiceItemKey(invoiceItem);
        const snapshot = this.state.invoiceDnResolutionSnapshots?.[invoiceKey];
        const hasSelection = Boolean(this.state.invoiceDnResolutionSelections?.[invoiceKey]);
        if (!snapshot && !hasSelection) {
            toast.info('Nothing to revert for this row');
            return;
        }

        this.setState({loading: true});
        try {
            let data = snapshot
                ? applyInvoiceItemSnapshot(invoiceItem, snapshot)
                : clearDnResolutionAssignmentFields(invoiceItem);
            data = this.calculateFields(data);
            const result = await this.persistResolvedInvoiceItem(data);
            if (result == null && !GeneralUtils.isNullOrEmpty(invoiceItem.id)) {
                toast.error('Could not revert item');
                return;
            }
            this.setState(prev => {
                const nextSnapshots = {...(prev.invoiceDnResolutionSnapshots || {})};
                const nextSelections = {...(prev.invoiceDnResolutionSelections || {})};
                const nextLabels = {...(prev.invoiceDnResolutionSelectionLabels || {})};
                delete nextSnapshots[invoiceKey];
                delete nextSelections[invoiceKey];
                delete nextLabels[invoiceKey];
                return {
                    invoiceDnResolutionSnapshots: nextSnapshots,
                    invoiceDnResolutionSelections: nextSelections,
                    invoiceDnResolutionSelectionLabels: nextLabels
                };
            }, () => this.persistDnResolutionStateToStorage());
        } catch (error) {
            console.error('DN resolution revert failed', error);
            toast.error('Could not revert item');
        } finally {
            this.setState({loading: false});
        }
    };

    renderDnResolutionOptions = (ranked) => {
        const groups = groupRankedDnOptions(ranked);
        const blocks = [
            {key: DN_MATCH_GROUP.SAME_BARCODE, label: 'Same barcode'},
            {key: DN_MATCH_GROUP.SIMILAR, label: 'Similar name'},
            {key: DN_MATCH_GROUP.OTHER, label: 'Other DN items'}
        ];
        return blocks.map(block => {
            const options = groups[block.key] || [];
            if (options.length === 0) {
                return null;
            }
            return (
                <optgroup key={block.key} label={block.label} className={`invoice-dn-resolution__optgroup--${block.key}`}>
                    {options.map(opt => {
                        const optKey = String(opt._dnKey || getDnItemKey(opt));
                        return (
                            <option
                                key={optKey}
                                value={optKey}
                                className={`invoice-dn-resolution__option--${block.key}`}
                            >
                                {formatDnOptionLabel(opt)}
                            </option>
                        );
                    })}
                </optgroup>
            );
        });
    };

    renderInvoiceDnResolutionSection() {
        if (!this.isUploadInvoice()) {
            return null;
        }
        if (GeneralUtils.isNullOrEmpty(this.state.license?.assignedDeliveryNoteId)
            || isNoneDeliveryNoteId(this.state.license?.assignedDeliveryNoteId)
            || this.isDeliveryNoteNoneSelected()) {
            return (
                <div className="text-muted" style={{padding: '16px 0'}}>
                    Select a closed Delivery Note above to resolve pending and duplicate invoice items.
                </div>
            );
        }

        const rows = this.getInvoiceDnResolutionRows();
        const dnItems = this.state.assignedDeliveryNote?.itemList || [];
        const editable = this.isInvoiceEditable();
        const selections = this.state.invoiceDnResolutionSelections || {};
        const selectionLabels = this.state.invoiceDnResolutionSelectionLabels || {};
        const snapshots = this.state.invoiceDnResolutionSnapshots || {};
        const dnNo = this.state.license.assignedDeliveryNoteNo
            || this.state.assignedDeliveryNote?.requisitionNo
            || '';

        return (
            <div className="invoice-dn-resolution">
                <div className="purchase-requisition-compare-dialog__summary">
                    {dnNo ? `Linked: ${dnNo}. ` : ''}
                    Resolve Pending and Duplicate invoice lines by assigning a Delivery Note item.
                </div>
                {rows.length === 0 ? (
                    <div className="text-muted" style={{padding: '12px 0'}}>
                        No pending or duplicate items to resolve.
                    </div>
                ) : (
                    <div className="invoice-dn-resolution__table-wrap">
                        <table className="invoice-dn-resolution__table">
                            <thead>
                                <tr>
                                    <th className="invoice-dn-resolution__col-name">Invoice Name</th>
                                    <th className="invoice-dn-resolution__col-barcode">Invoice Barcode</th>
                                    <th className="invoice-dn-resolution__col-dn">Delivery Note Item</th>
                                    <th className="invoice-dn-resolution__col-actions">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((item) => {
                                    const invoiceKey = getInvoiceItemKey(item);
                                    const selected = selections[invoiceKey] ? String(selections[invoiceKey]) : '';
                                    const availableDnItems = filterAvailableDnItems(
                                        dnItems,
                                        selections,
                                        invoiceKey,
                                        selected || null
                                    );
                                    const ranked = rankDeliveryNoteOptionsForInvoiceItem(item, availableDnItems);
                                    const canRevert = Boolean(snapshots[invoiceKey]) || Boolean(selected);
                                    const selectedOpt = ranked.find(
                                        opt => String(opt._dnKey || getDnItemKey(opt)) === selected
                                    );
                                    const selectTone = selectedOpt?._matchGroup
                                        || (canRevert ? DN_MATCH_GROUP.SAME_BARCODE : '');
                                    // Keep selected option visible even if ranking changes after assign.
                                    const selectedMissing = Boolean(selected) && !selectedOpt;
                                    const selectedLabel = selectionLabels[invoiceKey] || selected;
                                    return (
                                        <tr
                                            key={invoiceKey}
                                            className={canRevert ? 'invoice-dn-resolution__row--assigned' : ''}
                                        >
                                            <td className="invoice-dn-resolution__col-name">
                                                <div className="invoice-dn-resolution__name">
                                                    {item.itemName || item.longName || '—'}
                                                </div>
                                                {item.barcodeIsSearched !== true &&
                                                    <span className="invoice-dn-resolution__tag">Pending</span>
                                                }
                                                {canRevert &&
                                                    <span className="invoice-dn-resolution__tag invoice-dn-resolution__tag--assigned">
                                                        Assigned
                                                    </span>
                                                }
                                            </td>
                                            <td className="invoice-dn-resolution__col-barcode">
                                                {item.barcode || '—'}
                                            </td>
                                            <td className="invoice-dn-resolution__col-dn">
                                                <select
                                                    className={
                                                        `form-control form-control-sm invoice-dn-resolution__select`
                                                        + (selectTone ? ` invoice-dn-resolution__select--${selectTone}` : '')
                                                    }
                                                    disabled={!editable}
                                                    value={selected}
                                                    onChange={(e) => this.onInvoiceDnResolutionSelect(item, e.target.value)}
                                                >
                                                    <option value="">Select DN item…</option>
                                                    {selectedMissing &&
                                                        <option value={selected}>{selectedLabel}</option>
                                                    }
                                                    {this.renderDnResolutionOptions(ranked)}
                                                </select>
                                            </td>
                                            <td className="invoice-dn-resolution__col-actions">
                                                <Button
                                                    type="button"
                                                    color="outline-primary"
                                                    size="sm"
                                                    className="settings-page__btn--cancel"
                                                    disabled={!editable || !canRevert}
                                                    title={canRevert ? 'Restore original invoice values' : 'Assign a DN item first'}
                                                    onClick={() => this.revertInvoiceDnResolution(item)}
                                                >
                                                    Revert
                                                </Button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }

    openAssignDeliveryNoteDialog = () => {
        if (!this.isUploadInvoice()) {
            return;
        }
        if (GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            toast.warn('Please wait until the invoice is uploaded');
            return;
        }
        if (!this.checkSupplierApproved()) {
            toast.warn('Please approve supplier to continue');
            return;
        }
        if (GeneralUtils.isNullOrEmpty(this.state.license.supplierId)) {
            toast.warn('Please select a supplier first');
            return;
        }
        this.setState({
            selectedDeliveryNoteId: this.hasDeliveryNoteChoice() && !this.isDeliveryNoteNoneSelected()
                ? this.state.license.assignedDeliveryNoteId
                : null,
            displayAssignDeliveryNoteDialog: true,
            assignDeliveryNoteList: [],
            assignDeliveryNoteLoading: true
        }, () => this.loadAvailableDeliveryNotesForInvoice());
    };

    loadAvailableDeliveryNotesForInvoice = () => {
        const supplierId = this.state.license?.supplierId;
        if (GeneralUtils.isNullOrEmpty(supplierId)) {
            this.setState({
                assignDeliveryNoteList: [],
                unlinkedDeliveryNoteCount: 0,
                assignDeliveryNoteLoading: false
            });
            return;
        }
        this.setState({assignDeliveryNoteLoading: true});
        const gridModel = {
            filter: [],
            sort: [],
            pageNumber: 0,
            limit: 200
        };
        GeneralUtils.fetchWithAuth(
            SERVER_URL + 'inventory/PurchaseRequisition/available-delivery-notes/all/' + supplierId,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Softrame-BranchId': localStorage.getItem('merchantBranchId'),
                },
                body: JSON.stringify(gridModel)
            }
        ).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).then(result => {
            const rows = Array.isArray(result?.data) ? result.data : (Array.isArray(result) ? result : []);
            const dnRows = (rows || []).filter(row =>
                row && !row._isNone && !isNoneDeliveryNoteId(row.id) && row.requisitionNo !== 'NONE'
            );
            this.setState({
                assignDeliveryNoteList: dnRows,
                unlinkedDeliveryNoteCount: dnRows.length,
                assignDeliveryNoteLoading: false
            });
        }).catch(() => {
            this.setState({
                assignDeliveryNoteList: [],
                unlinkedDeliveryNoteCount: 0,
                assignDeliveryNoteLoading: false
            });
        });
    };

    /** Preview unlinked DN count for field banner (no dialog). */
    refreshUnlinkedDeliveryNoteCount = () => {
        if (!this.isUploadInvoice() || !this.isInvoiceEditable()) {
            return;
        }
        const supplierId = this.state.license?.supplierId;
        if (GeneralUtils.isNullOrEmpty(supplierId) || !this.checkSupplierApproved()) {
            this.setState({unlinkedDeliveryNoteCount: 0});
            return;
        }
        const gridModel = {
            filter: [],
            sort: [],
            pageNumber: 0,
            limit: 50
        };
        GeneralUtils.fetchWithAuth(
            SERVER_URL + 'inventory/PurchaseRequisition/available-delivery-notes/all/' + supplierId,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Softrame-BranchId': localStorage.getItem('merchantBranchId'),
                },
                body: JSON.stringify(gridModel)
            }
        ).then(response => {
            let result = response.clone();
            return GeneralUtils.responseToJson(result);
        }).then(result => {
            const rows = Array.isArray(result?.data) ? result.data : (Array.isArray(result) ? result : []);
            const count = (rows || []).filter(row =>
                row && !isNoneDeliveryNoteId(row.id) && row.requisitionNo !== 'NONE'
            ).length;
            this.setState({unlinkedDeliveryNoteCount: count});
        }).catch(() => {
            /* keep previous count */
        });
    };

    formatDeliveryNoteDayLabel = (value) => {
        if (!value) {
            return '';
        }
        const d = dayjs(value);
        if (!d.isValid()) {
            return '';
        }
        return d.format('dddd');
    };

    formatDeliveryNoteDateShort = (value) => {
        if (!value) {
            return '—';
        }
        if (typeof value === 'string' && value.includes('/')) {
            return value;
        }
        const d = dayjs(value);
        return d.isValid() ? d.format('DD/MM/YYYY') : String(value);
    };

    closeAssignDeliveryNoteDialog = () => {
        this.setState({
            displayAssignDeliveryNoteDialog: false,
            selectedDeliveryNoteId: null,
            assignDeliveryNoteList: [],
            assignDeliveryNoteLoading: false
        });
    };

    confirmAssignDeliveryNote = (options = {}) => {
        const purchaseOrderId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(purchaseOrderId)) {
            toast.warn('Please wait until the invoice is uploaded');
            return;
        }
        const deliveryNoteNone = options.deliveryNoteNone === true
            || isNoneDeliveryNoteId(this.state.selectedDeliveryNoteId);
        const selectedId = this.state.selectedDeliveryNoteId;
        const assignedDeliveryNoteId = deliveryNoteNone
            ? DELIVERY_NOTE_NONE_ID
            : (GeneralUtils.isNullOrEmpty(selectedId) ? null : Number(selectedId));
        if (!deliveryNoteNone && GeneralUtils.isNullOrEmpty(assignedDeliveryNoteId)) {
            toast.warn('Select a Delivery Note first, or choose Receive Stock Direct from Invoice');
            return;
        }
        if (!deliveryNoteNone && !GeneralUtils.isNullOrEmpty(assignedDeliveryNoteId) && !this.checkSupplierApproved()) {
            toast.warn('Please approve supplier to continue');
            return;
        }
        if (deliveryNoteNone && !this.checkSupplierApproved()) {
            toast.warn('Please approve supplier to continue');
            return;
        }
        // Optimistic UI so NONE is visible immediately even if API omits the flag.
        this.setState(prev => ({
            displayAssignDeliveryNoteDialog: false,
            selectedDeliveryNoteId: null,
            loading: true,
            license: {
                ...prev.license,
                assignedDeliveryNoteId: deliveryNoteNone
                    ? DELIVERY_NOTE_NONE_ID
                    : (assignedDeliveryNoteId ?? prev.license.assignedDeliveryNoteId),
                assignedDeliveryNoteNo: deliveryNoteNone ? 'NONE' : prev.license.assignedDeliveryNoteNo,
                deliveryNoteNone: deliveryNoteNone ? true : false
            },
            ...(deliveryNoteNone
                ? {
                    assignedDeliveryNote: null,
                    invoiceDnComparisonRows: [],
                    invoiceDnResolutionSnapshots: {},
                    invoiceDnResolutionSelections: {},
                    invoiceDnResolutionSelectionLabels: {},
                    invoiceDetailTabIndex: 0
                }
                : {})
        }));
        if (deliveryNoteNone) {
            clearDnResolutionState(purchaseOrderId);
        }
        this.purchaseOrderService.assignDeliveryNote(
            purchaseOrderId,
            deliveryNoteNone ? DELIVERY_NOTE_NONE_ID : assignedDeliveryNoteId,
            deliveryNoteNone
        ).then(response => {
            if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState(prev => ({
                    loading: false,
                    license: deliveryNoteNone
                        ? {
                            ...prev.license,
                            assignedDeliveryNoteId: DELIVERY_NOTE_NONE_ID,
                            assignedDeliveryNoteNo: 'NONE',
                            deliveryNoteNone: true
                        }
                        : prev.license
                }));
                return;
            }
            const noneSelected = deliveryNoteNone
                || isDeliveryNoteNoneFlag(response.deliveryNoteNone)
                || isNoneDeliveryNoteId(response.assignedDeliveryNoteId);
            this.setState(prev => ({
                license: {
                    ...prev.license,
                    assignedDeliveryNoteId: noneSelected
                        ? DELIVERY_NOTE_NONE_ID
                        : (response.assignedDeliveryNoteId ?? null),
                    assignedDeliveryNoteNo: noneSelected ? 'NONE' : (response.assignedDeliveryNoteNo || null),
                    deliveryNoteNone: noneSelected
                },
                loading: false
            }), () => {
                const dnId = noneSelected ? null : response.assignedDeliveryNoteId;
                this.loadAssignedDeliveryNoteForCompare(dnId);
                if (!noneSelected && !GeneralUtils.isNullOrEmpty(response.assignedDeliveryNoteId)) {
                    this.setState({invoiceDetailTabIndex: 1});
                    toast.success('Delivery Note linked. Stock will NOT be added again from this invoice.');
                } else if (noneSelected) {
                    toast.warn('Stock will be added from this invoice on Confirm.');
                } else {
                    this.setState({
                        invoiceDetailTabIndex: 0,
                        assignedDeliveryNote: null,
                        invoiceDnComparisonRows: []
                    });
                }
            });
        }).catch(() => {
            this.setState(prev => ({
                loading: false,
                license: deliveryNoteNone
                    ? {
                        ...prev.license,
                        assignedDeliveryNoteId: DELIVERY_NOTE_NONE_ID,
                        assignedDeliveryNoteNo: 'NONE',
                        deliveryNoteNone: true
                    }
                    : prev.license
            }));
        });
    };

    onAssignDeliveryNoteSelect = (data) => {
        if (!data?.id || isNoneDeliveryNoteId(data.id)) {
            return;
        }
        // Selection only — user must press “Link to Selected Delivery Note”.
        this.setState(prev => ({
            selectedDeliveryNoteId: Number(prev.selectedDeliveryNoteId) === Number(data.id)
                ? null
                : data.id
        }));
    };

    linkSelectedDeliveryNote = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.selectedDeliveryNoteId)
            || isNoneDeliveryNoteId(this.state.selectedDeliveryNoteId)) {
            toast.warn('Select a Delivery Note from the list first');
            return;
        }
        this.confirmAssignDeliveryNote({deliveryNoteNone: false});
    };

    selectNoneDeliveryNote = () => {
        // Already NONE — just close the picker
        if (this.isDeliveryNoteNoneSelected()) {
            this.closeAssignDeliveryNoteDialog();
            return;
        }
        this.setState({
            displayAssignDeliveryNoteDialog: false,
            selectedDeliveryNoteId: DELIVERY_NOTE_NONE_ID,
            showNoneDeliveryNoteConfirmModal: true
        });
    };

    confirmNoneDeliveryNoteSelection = () => {
        // Modal closes via ModalConfirm (ok then cancel). Only assign here.
        this.confirmAssignDeliveryNote({deliveryNoteNone: true});
    };

    cancelNoneDeliveryNoteSelection = () => {
        this.setState({
            showNoneDeliveryNoteConfirmModal: false,
            selectedDeliveryNoteId: null
        });
    };

    clearAssignedDeliveryNote = () => {
        // Clear back to "not chosen" so confirm forces a new selection.
        this.setState({selectedDeliveryNoteId: null}, () => {
            const purchaseOrderId = this.state.license?.id;
            if (GeneralUtils.isNullOrEmpty(purchaseOrderId)) {
                return;
            }
            this.setState({
                displayAssignDeliveryNoteDialog: false,
                loading: true
            });
            this.purchaseOrderService.assignDeliveryNote(purchaseOrderId, null, false).then(response => {
                if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({loading: false});
                    return;
                }
                this.setState(prev => ({
                    license: {
                        ...prev.license,
                        assignedDeliveryNoteId: null,
                        assignedDeliveryNoteNo: null,
                        deliveryNoteNone: false
                    },
                    assignedDeliveryNote: null,
                    invoiceDnComparisonRows: [],
                    invoiceDnResolutionSnapshots: {},
                    invoiceDnResolutionSelections: {},
                    invoiceDnResolutionSelectionLabels: {},
                    invoiceDetailTabIndex: 0,
                    loading: false
                }), () => {
                    clearDnResolutionState(purchaseOrderId);
                    this.refreshUnlinkedDeliveryNoteCount();
                });
            }).catch(() => this.setState({loading: false}));
        });
    };

    clearAssignedDeliveryNoteFromField = () => {
        if (!this.isInvoiceEditable() || GeneralUtils.isNullOrEmpty(this.state.license?.id)) {
            return;
        }
        if (!this.hasDeliveryNoteChoice()) {
            return;
        }
        this.clearAssignedDeliveryNote();
    };

    renderAssignDeliveryNoteDialog() {
        const list = this.state.assignDeliveryNoteList || [];
        const loading = this.state.assignDeliveryNoteLoading;
        const supplierName = this.state.license?.supplierName || 'this supplier';
        const count = list.length;
        const selectedId = this.state.selectedDeliveryNoteId;
        const hasSelection = !GeneralUtils.isNullOrEmpty(selectedId) && !isNoneDeliveryNoteId(selectedId);
        return (
            <Dialog
                visible={this.state.displayAssignDeliveryNoteDialog}
                header="Stock: Delivery Note or Invoice?"
                onHide={this.closeAssignDeliveryNoteDialog}
                style={{width: '760px', maxWidth: '96vw'}}
                className="invoice-dn-assign-dialog"
            >
                <div className="settings-page settings-page--dialog settings-page--lookup-picker purchase-requisition-assign-po-dialog">
                    <div className="invoice-dn-stock-alert">
                        <div className="invoice-dn-stock-alert__banner">
                            <span className="invoice-dn-stock-alert__icon" aria-hidden="true">
                                <i className="pi pi-exclamation-triangle"/>
                            </span>
                            <div>
                                <p className="invoice-dn-stock-alert__title">
                                    Unlinked Delivery Notes Found for {supplierName}
                                </p>
                                <p className="invoice-dn-stock-alert__subtitle">
                                    {count > 0
                                        ? `We found ${count} recent closed delivery note(s) that have not been billed yet. `
                                            + 'Does this invoice belong to one of them?'
                                        : 'No unlinked closed Delivery Notes for this supplier. '
                                            + 'You can receive stock direct from the invoice if there is no DN.'}
                                    {' '}
                                    Choosing wrong can <strong>duplicate stock</strong> (DN already added stock on confirm).
                                </p>
                            </div>
                        </div>
                        <div className="invoice-dn-stock-alert__rules">
                            <div className="invoice-dn-stock-alert__rule invoice-dn-stock-alert__rule--link">
                                <strong>Link Delivery Note</strong>
                                Stock will NOT be duplicated — invoice uses stock already posted from the DN.
                            </div>
                            <div className="invoice-dn-stock-alert__rule invoice-dn-stock-alert__rule--direct">
                                <strong>Receive stock from Invoice</strong>
                                Stock is added when you Confirm the invoice.
                            </div>
                        </div>
                    </div>

                    {count > 0 &&
                        <p className="invoice-dn-assign-dialog__question">
                            Select one Delivery Note below, then Link — or receive stock direct from invoice.
                        </p>
                    }

                    <div className="settings-page__table-wrap settings-page__table-wrap--lookup-dialog">
                        {loading &&
                            <div className="text-muted p-3">Loading closed Delivery Notes…</div>
                        }
                        {!loading && count > 0 &&
                            <div className="invoice-dn-assign-list">
                                <div className="invoice-dn-assign-list__head">
                                    <span/>
                                    <span>Delivery Note</span>
                                    <span>Date</span>
                                    <span>Approved</span>
                                </div>
                                <div className="invoice-dn-assign-list__body">
                                    {list.map(row => {
                                        const isSelected = Number(selectedId) === Number(row.id);
                                        const day = this.formatDeliveryNoteDayLabel(row.createDate || row.approvedDate);
                                        const createDate = this.formatDeliveryNoteDateShort(row.createDate);
                                        const approvedDate = row.approvedDate || row.checkoutDate
                                            ? (dayjs(row.approvedDate || row.checkoutDate).isValid()
                                                ? dayjs(row.approvedDate || row.checkoutDate).format('DD/MM/YYYY')
                                                : (row.approvedDate || row.checkoutDate))
                                            : '—';
                                        const label = [row.requisitionNo || '—', day ? `(${day})` : '']
                                            .filter(Boolean)
                                            .join(' ');
                                        return (
                                            <button
                                                type="button"
                                                key={String(row.id)}
                                                className={`invoice-dn-assign-list__row${isSelected ? ' invoice-dn-assign-list__row--selected' : ''}`}
                                                onClick={() => this.onAssignDeliveryNoteSelect(row)}
                                            >
                                                <input
                                                    type="radio"
                                                    className="invoice-dn-assign-list__check"
                                                    checked={isSelected}
                                                    readOnly
                                                    tabIndex={-1}
                                                    aria-label={label}
                                                />
                                                <span>
                                                    <strong>{row.requisitionNo || '—'}</strong>
                                                    {day ? ` (${day})` : ''}
                                                </span>
                                                <span>{createDate}</span>
                                                <span>{approvedDate}</span>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        }
                        {!loading && count === 0 &&
                            <div className="invoice-dn-assign-list__empty text-muted">
                                No unlinked closed Delivery Notes for this supplier.
                            </div>
                        }
                    </div>

                    <div className="invoice-dn-assign-dialog__cta-row">
                        <Button
                            color="success"
                            className="invoice-dn-assign-dialog__cta invoice-dn-assign-dialog__cta--link"
                            disabled={!hasSelection || loading}
                            onClick={this.linkSelectedDeliveryNote}
                        >
                            Link to Selected Delivery Note
                        </Button>
                        <Button
                            color="outline-danger"
                            className="invoice-dn-assign-dialog__cta invoice-dn-assign-dialog__cta--direct"
                            disabled={loading}
                            onClick={this.selectNoneDeliveryNote}
                        >
                            Receive Stock Direct from Invoice
                        </Button>
                    </div>

                    <div className="settings-page__actions settings-page__actions--dialog-footer purchase-requisition-assign-po-dialog__footer">
                        {this.hasDeliveryNoteChoice() &&
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--cancel"
                                onClick={this.clearAssignedDeliveryNote}
                            >
                                Clear choice
                            </Button>
                        }
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--cancel settings-page__btn--close"
                            onClick={this.closeAssignDeliveryNoteDialog}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }

    formatInvoiceMoney = (value) => {
        const n = Number(value);
        if (value == null || value === '' || Number.isNaN(n)) {
            return '—';
        }
        return `£${n.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
    };

    renderInvoiceHeaderSidePanel() {
        if (!this.showsDeliveryNoteSidePanel()) {
            return null;
        }
        return (
            <div className="invoice-detail-side-panel">
                {this.renderAssignedDeliveryNoteCard()}
            </div>
        );
    }

    renderAssignedDeliveryNoteCard() {
        if (!this.showsDeliveryNoteSidePanel()) {
            return null;
        }
        const locked = this.isFromDeliveryNoteInvoice();
        const assignedNo = this.getDeliveryNoteCardTitle();
        const editable = this.isInvoiceEditable() && !locked;
        const hasInvoiceId = !GeneralUtils.isNullOrEmpty(this.state.license.id);
        const canClear = editable && hasInvoiceId;
        const canSearch = canClear
            && this.checkSupplierApproved()
            && !GeneralUtils.isNullOrEmpty(this.state.license.supplierId);
        const hasChoice = locked
            ? (!GeneralUtils.isNullOrEmpty(this.state.license?.assignedDeliveryNoteId)
                && !isNoneDeliveryNoteId(this.state.license?.assignedDeliveryNoteId))
            : this.hasDeliveryNoteChoice();
        const isNone = !locked && this.isDeliveryNoteNoneSelected();
        const needsDn = editable && !hasChoice && Number(this.state.unlinkedDeliveryNoteCount) > 0;
        const searchTitle = !canSearch
            ? (!hasInvoiceId
                ? 'Upload invoice first'
                : (!this.checkSupplierApproved()
                    ? 'Please approve supplier to continue'
                    : 'Please select a supplier first'))
            : 'Choose Delivery Note or receive stock from invoice';
        const canOpenDn = hasChoice
            && !isNone
            && !GeneralUtils.isNullOrEmpty(this.state.license?.assignedDeliveryNoteId)
            && !isNoneDeliveryNoteId(this.state.license?.assignedDeliveryNoteId);
        return (
            <>
                <div
                    className={`purchase-requisition-po-card${isNone ? ' purchase-requisition-po-card--none-dn' : ''}${needsDn ? ' purchase-requisition-po-card--needs-dn' : ''}${locked ? ' purchase-requisition-po-card--locked' : ''}`}
                >
                    <div className="purchase-requisition-po-card__header">
                        <div>
                            <div className="purchase-requisition-po-card__eyebrow">
                                {locked ? 'Delivery Note' : 'Delivery Note *'}
                            </div>
                            <div
                                className={`purchase-requisition-po-card__title${
                                    isNone ? ' purchase-requisition-po-card__title--none' : ''
                                }${
                                    canOpenDn
                                        ? ' purchase-requisition-po-card__title--link'
                                        : ''
                                }`}
                                role={canOpenDn ? 'button' : undefined}
                                tabIndex={canOpenDn ? 0 : undefined}
                                title={canOpenDn
                                    ? 'Open Delivery Note'
                                    : (locked ? 'Linked from Delivery Note (read-only)' : undefined)}
                                onClick={canOpenDn
                                    ? () => {
                                        window.location.href = '#/purchaseRequisitionSave?'
                                            + this.state.license.assignedDeliveryNoteId;
                                    }
                                    : undefined}
                                onKeyDown={canOpenDn
                                    ? (e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            window.location.href = '#/purchaseRequisitionSave?'
                                                + this.state.license.assignedDeliveryNoteId;
                                        }
                                    }
                                    : undefined}
                            >
                                {assignedNo}
                            </div>
                            {locked &&
                                <div className="purchase-requisition-po-card__hint text-muted" style={{fontSize: '0.75rem', marginTop: '0.25rem'}}>
                                    Linked when created from Delivery Note
                                </div>
                            }
                        </div>
                        {!locked &&
                            <div className="purchase-requisition-po-card__actions">
                                {hasChoice && canClear &&
                                    <i
                                        className="pi pi-times purchase-requisition-po-card__search"
                                        role="button"
                                        tabIndex={0}
                                        title="Clear Delivery Note choice"
                                        onClick={this.clearAssignedDeliveryNoteFromField}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                this.clearAssignedDeliveryNoteFromField();
                                            }
                                        }}
                                    />
                                }
                                {editable &&
                                    <i
                                        className={`pi pi-search purchase-requisition-po-card__search${canSearch ? '' : ' is-disabled'}`}
                                        role="button"
                                        tabIndex={canSearch ? 0 : -1}
                                        title={searchTitle}
                                        onClick={() => {
                                            if (!canSearch) {
                                                return;
                                            }
                                            this.openAssignDeliveryNoteDialog();
                                        }}
                                        onKeyDown={(e) => {
                                            if (!canSearch) {
                                                return;
                                            }
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                this.openAssignDeliveryNoteDialog();
                                            }
                                        }}
                                    />
                                }
                            </div>
                        }
                    </div>
                    {needsDn && canSearch &&
                        <div
                            className="invoice-dn-field-banner"
                            role="button"
                            tabIndex={0}
                            onClick={this.openAssignDeliveryNoteDialog}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.openAssignDeliveryNoteDialog();
                                }
                            }}
                        >
                            <i className="pi pi-exclamation-triangle invoice-dn-field-banner__icon blinking-badge" aria-hidden="true"/>
                            {this.state.unlinkedDeliveryNoteCount} unlinked DN(s) — choose link or receive stock from invoice
                        </div>
                    }
                    {isNone && editable &&
                        <div className="invoice-dn-field-banner" style={{borderColor: '#fca5a5', background: '#fef2f2', color: '#991b1b'}}>
                            <i className="pi pi-info-circle" aria-hidden="true"/>
                            Direct from invoice — stock will add on Confirm (not from a DN)
                        </div>
                    }
                </div>
                {!locked && this.renderAssignDeliveryNoteDialog()}
                {!locked &&
                    <ModalConfirm
                        show={this.state.showNoneDeliveryNoteConfirmModal}
                        className="modal-confirm--stock"
                        header="Receive stock from invoice?"
                        message={
                            'STOCK WARNING\n\n'
                            + 'You chose: Receive Stock Direct from Invoice.\n\n'
                            + '• Stock WILL be updated when you Confirm this invoice.\n'
                            + '• If you should have linked a Delivery Note instead, stock was (or will be) posted on that DN — linking avoids double stock.\n\n'
                            + 'Continue with direct invoice stock?'
                        }
                        ok="Yes"
                        cancel="No"
                        onOkClick={this.confirmNoneDeliveryNoteSelection}
                        onCancelClick={this.cancelNoneDeliveryNoteSelection}
                    />
                }
            </>
        );
    }
}
